/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64JSON: { input: any; output: any; }
  Decimal: { input: string; output: string; }
  Time: { input: Date; output: Date; }
  Upload: { input: any; output: any; }
};

export type App = {
  __typename?: 'App';
  createdAt: Scalars['Time']['output'];
  createdBy: User;
  defaultDeployment?: Maybe<AppDeployment>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  subscription?: Maybe<AppSubscription>;
};

export type AppApiKey = {
  __typename?: 'AppAPIKey';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type AppApiKeyAlreadyExists = {
  __typename?: 'AppAPIKeyAlreadyExists';
  name: Scalars['String']['output'];
};

export type AppApiKeyCreateResult = AppApiKey | AppApiKeyAlreadyExists | AppApiKeyInvalidName;

export type AppApiKeyInvalidName = {
  __typename?: 'AppAPIKeyInvalidName';
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type AppBuildErrorEvent = {
  __typename?: 'AppBuildErrorEvent';
  message: Scalars['String']['output'];
};

export type AppBuildMessageEvent = {
  __typename?: 'AppBuildMessageEvent';
  message: Scalars['String']['output'];
};

export type AppCreateInfo = {
  appSlug: Scalars['String']['input'];
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
};

export type AppDeleteInput = {
  appSlug: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
};

export type AppDeleteResult = AppDeleted | AppHasActiveSubscriptions;

export type AppDeleted = {
  __typename?: 'AppDeleted';
  appSlug: Scalars['String']['output'];
  organizationSlug?: Maybe<Scalars['String']['output']>;
};

export type AppDeployEvent = AppBuildErrorEvent | AppBuildMessageEvent | AppDeploymentStatusEvent;

export type AppDeployInput = {
  appRelativePath?: InputMaybe<Scalars['String']['input']>;
  secrets?: InputMaybe<Array<AppSecret>>;
  skipMetadataUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppDeployLogEntry = {
  __typename?: 'AppDeployLogEntry';
  text: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
};

export type AppDeployLogEntryConnection = {
  __typename?: 'AppDeployLogEntryConnection';
  edges: Array<AppDeployLogEntry>;
  pageInfo: PageInfo;
};

export type AppDeployLogsInput = {
  appSlug: Scalars['String']['input'];
  follow?: InputMaybe<Scalars['Boolean']['input']>;
  organizationSlug: Scalars['String']['input'];
  tail?: InputMaybe<Scalars['Int']['input']>;
};

export type AppDeployment = {
  __typename?: 'AppDeployment';
  apiDocsPath?: Maybe<Scalars['String']['output']>;
  apiKeys: Array<Maybe<AppApiKey>>;
  apiURL?: Maybe<Scalars['String']['output']>;
  current?: Maybe<AppDeploymentVersion>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sharedURL?: Maybe<Scalars['String']['output']>;
};

export type AppDeploymentHeartbeat = {
  __typename?: 'AppDeploymentHeartbeat';
  proxyURL?: Maybe<Scalars['String']['output']>;
  status: AppDeploymentStatus;
};

export type AppDeploymentResourceUsage = {
  __typename?: 'AppDeploymentResourceUsage';
  current: Scalars['Float']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  timeseries?: Maybe<Array<AppDeploymentResourceUsageDataPoint>>;
};

export type AppDeploymentResourceUsageDataPoint = {
  __typename?: 'AppDeploymentResourceUsageDataPoint';
  timestamp: Scalars['Time']['output'];
  value: Scalars['Float']['output'];
};

export enum AppDeploymentStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type AppDeploymentStatusEvent = {
  __typename?: 'AppDeploymentStatusEvent';
  status?: Maybe<AppDeploymentStatus>;
};

export type AppDeploymentVersion = {
  __typename?: 'AppDeploymentVersion';
  appVersion: AppVersion;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  proxyURL?: Maybe<Scalars['String']['output']>;
  status: AppDeploymentStatus;
};

export type AppDeploymentWorkload = {
  __typename?: 'AppDeploymentWorkload';
  cpuUsage?: Maybe<AppDeploymentResourceUsage>;
  logs: AppDeployLogEntryConnection;
  memoryUsageMB?: Maybe<AppDeploymentResourceUsage>;
  organization?: Maybe<Organization>;
  startedAt: Scalars['Time']['output'];
  status: AppDeploymentStatus;
  subscription?: Maybe<AppSubscription>;
};


export type AppDeploymentWorkloadLogsArgs = {
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AppDescriptionUpdateInput = {
  appDescription?: InputMaybe<Scalars['String']['input']>;
  appID: Scalars['ID']['input'];
};

export type AppHasActiveSubscriptions = {
  __typename?: 'AppHasActiveSubscriptions';
  activeStandingOffersCount: Scalars['Int']['output'];
  activeSubscriptionOffersCount: Scalars['Int']['output'];
  activeSubscriptionsCount: Scalars['Int']['output'];
  appSlug: Scalars['String']['output'];
};

export type AppRenameInput = {
  appID: Scalars['ID']['input'];
  appName: Scalars['String']['input'];
};

export type AppSecret = {
  base64Value: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AppSession = {
  __typename?: 'AppSession';
  accessType: AppSessionAccessType;
  app: App;
  endTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  ownerOrganization: Scalars['String']['output'];
  startTime: Scalars['Time']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export enum AppSessionAccessType {
  Owner = 'OWNER',
  Shared = 'SHARED',
  Subscription = 'SUBSCRIPTION'
}

export type AppSessionConnection = {
  __typename?: 'AppSessionConnection';
  edges: Array<AppSessionEdge>;
  pageInfo: PageInfo;
};

export type AppSessionEdge = {
  __typename?: 'AppSessionEdge';
  cursor: Scalars['ID']['output'];
  node: AppSession;
};

export type AppSessionStarted = {
  __typename?: 'AppSessionStarted';
  sessionId: Scalars['ID']['output'];
};

export type AppSessionsFilterInput = {
  accessType?: InputMaybe<AppSessionAccessType>;
  appSlug?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  organizationSlug?: InputMaybe<Scalars['String']['input']>;
  startTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  startTimeTo?: InputMaybe<Scalars['Time']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AppSubscription = {
  __typename?: 'AppSubscription';
  apiKeys: Array<Maybe<AppApiKey>>;
  app: App;
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  inboundOrganization: Organization;
  monthlyPriceUSD?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outboundOrganization: Organization;
  status: AppSubscriptionStatus;
};

export type AppSubscriptionCancelResult = AppSubscription | AppSubscriptionInvalidStatus | AppSubscriptionNotFound;

export type AppSubscriptionInvalidStatus = {
  __typename?: 'AppSubscriptionInvalidStatus';
  id: Scalars['ID']['output'];
};

export type AppSubscriptionNotFound = {
  __typename?: 'AppSubscriptionNotFound';
  id: Scalars['ID']['output'];
};

export enum AppSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Withdrawn = 'WITHDRAWN'
}

export type AppVersion = {
  __typename?: 'AppVersion';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  releaseNotes?: Maybe<AppVersionDocumentationFile>;
  tasks: Array<Task>;
  userGuide?: Maybe<AppVersionDocumentationFile>;
  version: Scalars['String']['output'];
};

export type AppVersionCreateGitHubInput = {
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};

export type AppVersionCreateGitHubResult = AppVersion | GitHubRepositoryNotFound;

export type AppVersionDocumentationFile = {
  __typename?: 'AppVersionDocumentationFile';
  contentBase64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type AppVersionDownloadUrl = {
  __typename?: 'AppVersionDownloadURL';
  url: Scalars['String']['output'];
};

export type AppVersionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type AppVersionUploadUrl = {
  __typename?: 'AppVersionUploadURL';
  url: Scalars['String']['output'];
};

export type AppWorkloadsInput = {
  metricsSince?: InputMaybe<Scalars['Time']['input']>;
};

export type Auth0WhiteLabelInvitation = {
  __typename?: 'Auth0WhiteLabelInvitation';
  email: Scalars['String']['output'];
  invitedAt: Scalars['Time']['output'];
};

export type Auth0WhiteLabelInvitationInput = {
  email: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
};

export enum AuthRole {
  Admin = 'ADMIN',
  Authenticated = 'AUTHENTICATED',
  User = 'USER'
}

export type BuildEvent = BuildEventFailure | BuildEventInfo | BuildEventSuccess;

export type BuildEventFailure = {
  __typename?: 'BuildEventFailure';
  result: Scalars['String']['output'];
};

export type BuildEventInfo = {
  __typename?: 'BuildEventInfo';
  result: Scalars['String']['output'];
};

export type BuildEventSuccess = {
  __typename?: 'BuildEventSuccess';
  result: Scalars['String']['output'];
};

export type BuildPushInput = {
  secrets?: InputMaybe<Array<AppSecret>>;
};

export type Collection = {
  __typename?: 'Collection';
  collections: CollectionConnection;
  document?: Maybe<CollectionDocument>;
  documents: CollectionDocumentConnection;
  files: CollectionFileConnection;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  tags: Array<Tag>;
};


export type CollectionCollectionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagInput>;
};


export type CollectionDocumentArgs = {
  key: Scalars['ID']['input'];
};


export type CollectionDocumentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagInput>;
};


export type CollectionFilesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<TagInput>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  edges: Array<CollectionEdge>;
  pageInfo: PageInfo;
};

export type CollectionCreateResult = Collection | CollectionNotFound | CollectionOrganizationMismatch;

export type CollectionDocument = {
  __typename?: 'CollectionDocument';
  data: Scalars['Base64JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  tags: Array<Tag>;
};

export type CollectionDocumentConnection = {
  __typename?: 'CollectionDocumentConnection';
  edges: Array<CollectionDocumentEdge>;
  pageInfo: PageInfo;
};

export type CollectionDocumentDeleteResult = CollectionDocument | CollectionDocumentNotFound;

export type CollectionDocumentEdge = {
  __typename?: 'CollectionDocumentEdge';
  cursor: Scalars['ID']['output'];
  node: CollectionDocument;
};

export type CollectionDocumentNotFound = {
  __typename?: 'CollectionDocumentNotFound';
  id: Scalars['ID']['output'];
};

export type CollectionDocumentResult = CollectionDocument | CollectionDocumentNotFound;

export type CollectionDocumentSetResult = CollectionDocument | CollectionNotFound;

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  cursor: Scalars['ID']['output'];
  node: Collection;
};

export type CollectionFile = {
  __typename?: 'CollectionFile';
  downloadURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  tags: Array<Tag>;
  uploadURL?: Maybe<Scalars['String']['output']>;
};

export type CollectionFileConnection = {
  __typename?: 'CollectionFileConnection';
  edges: Array<CollectionFileEdge>;
  pageInfo: PageInfo;
};

export type CollectionFileCreateResult = CollectionFile | CollectionNotFound;

export type CollectionFileDeleteResult = CollectionFile | CollectionFileNotFound;

export type CollectionFileEdge = {
  __typename?: 'CollectionFileEdge';
  cursor: Scalars['ID']['output'];
  node: CollectionFile;
};

export type CollectionFileNotFound = {
  __typename?: 'CollectionFileNotFound';
  id: Scalars['ID']['output'];
};

export type CollectionFileResult = CollectionFile | CollectionFileNotFound;

export type CollectionNotFound = {
  __typename?: 'CollectionNotFound';
  id: Scalars['ID']['output'];
};

export type CollectionOrganizationMismatch = {
  __typename?: 'CollectionOrganizationMismatch';
  parentID: Scalars['ID']['output'];
  parentOrganizationID: Scalars['ID']['output'];
  requestedOrganizationID: Scalars['ID']['output'];
};

export type CollectionResult = Collection | CollectionNotFound;

export type CustomerAccountPortalUrl = {
  __typename?: 'CustomerAccountPortalURL';
  url: Scalars['String']['output'];
};

export enum EmailNotificationCategory {
  DeploymentUpdates = 'DEPLOYMENT_UPDATES',
  Marketing = 'MARKETING',
  Onboarding = 'ONBOARDING',
  OrganizationUpdates = 'ORGANIZATION_UPDATES',
  ReleaseNotes = 'RELEASE_NOTES'
}

export type EmailNotificationPreferences = {
  __typename?: 'EmailNotificationPreferences';
  DeploymentUpdatesDisabled?: Maybe<Scalars['Boolean']['output']>;
  MarketingDisabled?: Maybe<Scalars['Boolean']['output']>;
  OnboardingDisabled?: Maybe<Scalars['Boolean']['output']>;
  OrganizationUpdatesDisabled?: Maybe<Scalars['Boolean']['output']>;
  ReleaseNotesDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Enterprise = {
  __typename?: 'Enterprise';
  hasCustomerAccount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  members: Array<User>;
  name: Scalars['String']['output'];
  organizations: Array<Organization>;
  paymentAccount?: Maybe<PaymentAccount>;
  plan: EnterprisePlan;
  slug: Scalars['String']['output'];
};

export type EnterpriseCreateResult = Enterprise | EnterpriseInvalidMaxOrganizations | EnterpriseInvalidUnitsCount | EnterpriseSlugInvalid;

export type EnterpriseInvalidMaxOrganizations = {
  __typename?: 'EnterpriseInvalidMaxOrganizations';
  maxOrganizations: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type EnterpriseInvalidUnitsCount = {
  __typename?: 'EnterpriseInvalidUnitsCount';
  reason: Scalars['String']['output'];
  unitsCount: Scalars['Decimal']['output'];
};

export type EnterpriseMemberAddInput = {
  enterpriseId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type EnterpriseMemberAddResult = Enterprise | EnterpriseNotFound | UserNotFound;

export type EnterpriseMemberRemoveInput = {
  enterpriseId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type EnterpriseMemberRemoveResult = Enterprise | EnterpriseNotFound | UserNotFound;

export type EnterpriseNotFound = {
  __typename?: 'EnterpriseNotFound';
  id: Scalars['ID']['output'];
};

export type EnterprisePlan = {
  __typename?: 'EnterprisePlan';
  maxOrganizations: Scalars['Int']['output'];
  unitsCount: Scalars['Decimal']['output'];
};

export type EnterprisePlanChangeInput = {
  enterpriseId: Scalars['ID']['input'];
  maxOrganizations?: InputMaybe<Scalars['Int']['input']>;
  unitsCount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EnterprisePlanChangeResult = Enterprise | EnterpriseInvalidMaxOrganizations | EnterpriseInvalidUnitsCount | EnterpriseNotFound;

export type EnterprisePlanInput = {
  maxOrganizations: Scalars['Int']['input'];
  unitsCount: Scalars['Decimal']['input'];
};

export type EnterpriseQueryResult = Enterprise | EnterpriseNotFound;

export type EnterpriseSlugInvalid = {
  __typename?: 'EnterpriseSlugInvalid';
  slug: Scalars['String']['output'];
};

export type FeedbackInput = {
  message: Scalars['String']['input'];
  whiteLabelConfigID?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackResult = {
  __typename?: 'FeedbackResult';
  email: Scalars['String']['output'];
};

export type GitHubRepositoryNotFound = {
  __typename?: 'GitHubRepositoryNotFound';
  owner: Scalars['String']['output'];
  repo: Scalars['String']['output'];
};

export type GithubRepositoryRelease = {
  __typename?: 'GithubRepositoryRelease';
  body: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedAt: Scalars['Time']['output'];
};

export type InvalidEmail = {
  __typename?: 'InvalidEmail';
  email: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  proxyUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type JobHeartbeatFailure = {
  __typename?: 'JobHeartbeatFailure';
  result: Scalars['String']['output'];
};

export type JobHeartbeatResult = JobHeartbeatFailure | JobHeartbeatSuccess | JobNotFound;

export type JobHeartbeatSuccess = {
  __typename?: 'JobHeartbeatSuccess';
  id: Scalars['ID']['output'];
};

export type JobNotFound = {
  __typename?: 'JobNotFound';
  id: Scalars['ID']['output'];
};

export type LogMessage = {
  __typename?: 'LogMessage';
  message: Scalars['String']['output'];
  time: Scalars['Time']['output'];
};

export type MeDeleteResult = UserDeleted | UserHasSoleAdminship | UserNotFound;

export type Mutation = {
  __typename?: 'Mutation';
  Auth0WhiteLabelInvitationCreate: Auth0WhiteLabelInvitation;
  appAPIKeyRename: AppApiKeyRenameResult;
  appAPIKeyRevoke: AppApiKey;
  appCreate: App;
  appDelete: AppDeleteResult;
  appDeploy: AppDeploymentVersion;
  appDeployHeartbeat: AppDeploymentHeartbeat;
  appDeployShare: AppDeployment;
  appDeployUnshare: AppDeployment;
  appDeploymentAPIKeyCreate: AppApiKeyCreateResult;
  appDescriptionUpdate?: Maybe<App>;
  appRename?: Maybe<App>;
  appSharedDeployHeartbeat: AppDeploymentHeartbeat;
  appSubscriptionAPIKeyCreate: AppApiKeyCreateResult;
  appVersionCreate: AppVersion;
  appVersionCreateGitHub?: Maybe<AppVersionCreateGitHubResult>;
  appVersionDownloadURL: AppVersionDownloadUrl;
  appVersionUploadURL: AppVersionUploadUrl;
  buildPush: BuildConfiguration;
  collectionCreate: CollectionCreateResult;
  collectionDocumentDelete: CollectionDocumentDeleteResult;
  collectionDocumentSet: CollectionDocumentSetResult;
  collectionDocumentTagAdd: CollectionDocumentResult;
  collectionDocumentTagDelete: CollectionDocumentResult;
  collectionFileCreate: CollectionFileCreateResult;
  collectionFileDelete: CollectionFileDeleteResult;
  collectionFileTagAdd: CollectionFileResult;
  collectionFileTagDelete: CollectionFileResult;
  collectionTagAdd: CollectionResult;
  collectionTagDelete: CollectionResult;
  customerAccountCreatePortalURL: CustomerAccountPortalUrl;
  enterpriseCreate: EnterpriseCreateResult;
  enterpriseMemberAdd: EnterpriseMemberAddResult;
  enterpriseMemberRemove: EnterpriseMemberRemoveResult;
  enterprisePlanChange: EnterprisePlanChangeResult;
  jobHeartbeat: JobHeartbeatResult;
  jobStart: Job;
  jobStop: StopJobPayload;
  meDelete: MeDeleteResult;
  organizationCreate: OrganizationCreateResult;
  organizationDelete: OrganizationDeleteResult;
  organizationInvitationAccept?: Maybe<OrganizationInvitationAcceptResult>;
  organizationInvitationCreate: OrganizationInvitationCreateResult;
  organizationInvitationDelete?: Maybe<OrganizationInvitationDeleteResult>;
  organizationInvitationReject?: Maybe<OrganizationInvitationRejectResult>;
  organizationLinkToEnterprise: OrganizationLinkToEnterpriseResult;
  organizationMemberEditRole: OrganizationMemberEditRoleResult;
  organizationMemberRemove: OrganizationMemberRemoveResult;
  organizationRename: OrganizationRenameResult;
  organizationTierChange: OrganizationTierChangeResult;
  paymentAccountCreate: PaymentAccountCreateResult;
  paymentAccountDelete: PaymentAccountDeleteResult;
  paymentAccountOnboardURLCreate: PaymentAccountUrlResult;
  paymentAccountUpdateURLCreate: PaymentAccountUrlResult;
  personalAccessTokenCreate: PersonalAccessTokenCreateResult;
  personalAccessTokenRevoke: PersonalAccessTokenEntry;
  resendEmailVerification: ResendEmailVerificationResult;
  sendFeedback: FeedbackResult;
  sendPlatformMail?: Maybe<PlatformMail>;
  sendRequestWhiteLabelAccessMail: RequestWhiteLabelAccessResult;
  standingOfferAccept: StandingOfferAcceptResult;
  standingOfferCancel: StandingOfferResult;
  standingOfferCreate: StandingOfferCreateResult;
  subscriptionCancelInbound: AppSubscriptionCancelResult;
  subscriptionCancelOutbound: AppSubscriptionCancelResult;
  subscriptionDeployHeartbeat: AppDeploymentHeartbeat;
  subscriptionOfferAccept: SubscriptionOfferAcceptResult;
  subscriptionOfferCreate: SubscriptionOfferCreateResult;
  subscriptionOfferReject: SubscriptionOfferRejectResult;
  subscriptionOfferWithdraw: SubscriptionOfferWithdraw;
  taskInstanceSetOutput: TaskInstance;
  taskInstanceUpdateProgress: TaskInstance;
  taskStart: TaskInstance;
  taskStop: TaskStopResult;
  toolCreate: Tool;
  toolDelete: ToolDeleteResult;
  toolPublish: Tool;
  toolUnpublish: Tool;
  userEmailNotificationPreferenceUpdate: User;
  userOnboardingDisable: User;
  userOnboardingEnable: User;
  userRename?: Maybe<User>;
};


export type MutationAuth0WhiteLabelInvitationCreateArgs = {
  input?: InputMaybe<Auth0WhiteLabelInvitationInput>;
};


export type MutationAppApiKeyRenameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAppApiKeyRevokeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppCreateArgs = {
  appData: AppCreateInfo;
  organizationSlug: Scalars['String']['input'];
};


export type MutationAppDeleteArgs = {
  input: AppDeleteInput;
};


export type MutationAppDeployArgs = {
  appVersionID: Scalars['ID']['input'];
  input?: InputMaybe<AppDeployInput>;
};


export type MutationAppDeployHeartbeatArgs = {
  deployID: Scalars['ID']['input'];
};


export type MutationAppDeployShareArgs = {
  deployID: Scalars['ID']['input'];
};


export type MutationAppDeployUnshareArgs = {
  deployID: Scalars['ID']['input'];
};


export type MutationAppDeploymentApiKeyCreateArgs = {
  deployID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationAppDescriptionUpdateArgs = {
  appData: AppDescriptionUpdateInput;
  organizationSlug: Scalars['String']['input'];
};


export type MutationAppRenameArgs = {
  appData: AppRenameInput;
  organizationSlug: Scalars['String']['input'];
};


export type MutationAppSharedDeployHeartbeatArgs = {
  sharedURLID: Scalars['ID']['input'];
};


export type MutationAppSubscriptionApiKeyCreateArgs = {
  name: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationAppVersionCreateArgs = {
  appID: Scalars['ID']['input'];
  input?: InputMaybe<AppVersionInput>;
};


export type MutationAppVersionCreateGitHubArgs = {
  appID: Scalars['ID']['input'];
  input: AppVersionCreateGitHubInput;
};


export type MutationAppVersionDownloadUrlArgs = {
  appVersionID: Scalars['ID']['input'];
};


export type MutationAppVersionUploadUrlArgs = {
  appVersionID: Scalars['ID']['input'];
};


export type MutationBuildPushArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
  input?: InputMaybe<BuildPushInput>;
};


export type MutationCollectionCreateArgs = {
  key: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  parentID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCollectionDocumentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCollectionDocumentSetArgs = {
  collectionID: Scalars['ID']['input'];
  data: Scalars['Base64JSON']['input'];
  key: Scalars['ID']['input'];
};


export type MutationCollectionDocumentTagAddArgs = {
  id: Scalars['ID']['input'];
  tag: TagInput;
};


export type MutationCollectionDocumentTagDeleteArgs = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type MutationCollectionFileCreateArgs = {
  collectionID: Scalars['ID']['input'];
  key: Scalars['ID']['input'];
};


export type MutationCollectionFileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCollectionFileTagAddArgs = {
  id: Scalars['ID']['input'];
  tag: TagInput;
};


export type MutationCollectionFileTagDeleteArgs = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type MutationCollectionTagAddArgs = {
  collectionID: Scalars['ID']['input'];
  tag: TagInput;
};


export type MutationCollectionTagDeleteArgs = {
  collectionID: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};


export type MutationCustomerAccountCreatePortalUrlArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationEnterpriseCreateArgs = {
  input: NewEnterprise;
};


export type MutationEnterpriseMemberAddArgs = {
  input: EnterpriseMemberAddInput;
};


export type MutationEnterpriseMemberRemoveArgs = {
  input: EnterpriseMemberRemoveInput;
};


export type MutationEnterprisePlanChangeArgs = {
  input: EnterprisePlanChangeInput;
};


export type MutationJobHeartbeatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJobStartArgs = {
  hashType: ToolHashType;
  toolHash: Scalars['ID']['input'];
};


export type MutationJobStopArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganizationCreateArgs = {
  input: NewOrganization;
};


export type MutationOrganizationDeleteArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationInvitationAcceptArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationOrganizationInvitationCreateArgs = {
  input?: InputMaybe<OrganizationInvitationInput>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationInvitationDeleteArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationOrganizationInvitationRejectArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationOrganizationLinkToEnterpriseArgs = {
  enterpriseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationMemberEditRoleArgs = {
  input: OrganizationMemberEditRoleInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationMemberRemoveArgs = {
  memberId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationRenameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationTierChangeArgs = {
  input: OrganizationTierChangeInput;
};


export type MutationPaymentAccountCreateArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type MutationPaymentAccountDeleteArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type MutationPaymentAccountOnboardUrlCreateArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type MutationPaymentAccountUpdateUrlCreateArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type MutationPersonalAccessTokenCreateArgs = {
  input: PersonalAccessTokenCreateInput;
};


export type MutationPersonalAccessTokenRevokeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendEmailVerificationArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationSendFeedbackArgs = {
  input?: InputMaybe<FeedbackInput>;
};


export type MutationSendPlatformMailArgs = {
  input: PlatformMailInput;
};


export type MutationSendRequestWhiteLabelAccessMailArgs = {
  input: RequestWhiteLabelAccessMailInput;
};


export type MutationStandingOfferAcceptArgs = {
  organizationId: Scalars['ID']['input'];
  standingOfferId: Scalars['ID']['input'];
};


export type MutationStandingOfferCancelArgs = {
  organizationId: Scalars['ID']['input'];
  standingOfferId: Scalars['ID']['input'];
};


export type MutationStandingOfferCreateArgs = {
  input: StandingOfferInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationSubscriptionCancelInboundArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationSubscriptionCancelOutboundArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationSubscriptionDeployHeartbeatArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationSubscriptionOfferAcceptArgs = {
  organizationId: Scalars['ID']['input'];
  subscriptionOfferId: Scalars['ID']['input'];
};


export type MutationSubscriptionOfferCreateArgs = {
  input: SubscriptionOfferInput;
  organizationId: Scalars['ID']['input'];
};


export type MutationSubscriptionOfferRejectArgs = {
  subscriptionOfferId: Scalars['ID']['input'];
};


export type MutationSubscriptionOfferWithdrawArgs = {
  subscriptionOfferId: Scalars['ID']['input'];
};


export type MutationTaskInstanceSetOutputArgs = {
  taskInstanceID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationTaskInstanceUpdateProgressArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  taskInstanceID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationTaskStartArgs = {
  input: TaskStartInput;
};


export type MutationTaskStopArgs = {
  taskInstanceID: Scalars['ID']['input'];
};


export type MutationToolCreateArgs = {
  input: NewTool;
};


export type MutationToolDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToolPublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToolUnpublishArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserEmailNotificationPreferenceUpdateArgs = {
  emailCategory: EmailNotificationCategory;
  value: Scalars['Boolean']['input'];
};


export type MutationUserRenameArgs = {
  fullName: Scalars['String']['input'];
};

export type NewEnterprise = {
  name: Scalars['String']['input'];
  plan: EnterprisePlanInput;
  slug: Scalars['String']['input'];
};

export type NewOrganization = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  whiteLabelDomain?: InputMaybe<Scalars['String']['input']>;
};

export type NewTool = {
  manifest: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type OfferInvalidExpiresAt = {
  __typename?: 'OfferInvalidExpiresAt';
  expiresAt: Scalars['Time']['output'];
};

export type OfferInvalidMonthlyPriceUsd = {
  __typename?: 'OfferInvalidMonthlyPriceUSD';
  monthlyPriceUSD: Scalars['Decimal']['output'];
};

export type OfferInvalidTrialDays = {
  __typename?: 'OfferInvalidTrialDays';
  maxTrialDays: Scalars['Int']['output'];
  trialDays: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  appSessions: AppSessionConnection;
  apps: Array<App>;
  createdAt: Scalars['Time']['output'];
  enterprise?: Maybe<Enterprise>;
  hasCustomerAccount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  members: Array<OrganizationMembership>;
  name: Scalars['String']['output'];
  outboundSubscriptionOffers: Array<SubscriptionOffer>;
  outboundSubscriptions: Array<AppSubscription>;
  paymentAccount?: Maybe<PaymentAccount>;
  pendingInvitations: Array<OrganizationInvitation>;
  slug: Scalars['String']['output'];
  standingOffers: Array<StandingOffer>;
  tier?: Maybe<OrganizationTier>;
  tierExpiresAt?: Maybe<Scalars['Time']['output']>;
};


export type OrganizationAppSessionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<OrganizationAppSessionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAppSessionsFilterInput = {
  accessType?: InputMaybe<AppSessionAccessType>;
  appSlug?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  startTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  startTimeTo?: InputMaybe<Scalars['Time']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationCreateResult = Organization | OrganizationSlugInvalid | OrganizationSlugOccupied;

export type OrganizationDeleteResult = OrganizationDeleted | OrganizationHasApps | OrganizationHasInboundSubscriptions | OrganizationNotFound;

export type OrganizationDeleted = {
  __typename?: 'OrganizationDeleted';
  id: Scalars['ID']['output'];
};

export type OrganizationHasApps = {
  __typename?: 'OrganizationHasApps';
  id: Scalars['ID']['output'];
};

export type OrganizationHasInboundSubscriptions = {
  __typename?: 'OrganizationHasInboundSubscriptions';
  id: Scalars['ID']['output'];
};

export type OrganizationHasNoPaymentAccount = {
  __typename?: 'OrganizationHasNoPaymentAccount';
  organizationID: Scalars['ID']['output'];
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedAt: Scalars['Time']['output'];
  organizationName: Scalars['String']['output'];
  role: Role;
};

export type OrganizationInvitationAcceptResult = Organization | OrganizationNotFound;

export type OrganizationInvitationCreateResult = InvalidEmail | OrganizationInvitation | OrganizationInvitationExists | OrganizationNotFound;

export type OrganizationInvitationDeleteResult = OrganizationInvitationDeleted | OrganizationInvitationNotFound | OrganizationNotFound;

export type OrganizationInvitationDeleted = {
  __typename?: 'OrganizationInvitationDeleted';
  id: Scalars['ID']['output'];
};

export type OrganizationInvitationExists = {
  __typename?: 'OrganizationInvitationExists';
  email: Scalars['String']['output'];
};

export type OrganizationInvitationInput = {
  email: Scalars['String']['input'];
  role: Role;
};

export type OrganizationInvitationNotFound = {
  __typename?: 'OrganizationInvitationNotFound';
  id: Scalars['ID']['output'];
};

export type OrganizationInvitationQueryResult = OrganizationInvitation | OrganizationInvitationNotFound | OrganizationNotFound;

export type OrganizationInvitationRejectResult = OrganizationInvitationNotFound | OrganizationInvitationRejected | OrganizationNotFound;

export type OrganizationInvitationRejected = {
  __typename?: 'OrganizationInvitationRejected';
  id: Scalars['ID']['output'];
};

export type OrganizationLinkToEnterpriseResult = EnterpriseNotFound | Organization | OrganizationNotFound;

export type OrganizationMemberEditRoleInput = {
  role: Role;
  userId: Scalars['ID']['input'];
};

export type OrganizationMemberEditRoleResult = OrganizationMembership | OrganizationNotFound | UserNotFound;

export type OrganizationMemberRemoveResult = Organization | OrganizationNotFound | UserNotFound;

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  id: Scalars['ID']['output'];
  organization: Organization;
  role: Role;
  user: User;
};

export type OrganizationMissingPaymentMethod = {
  __typename?: 'OrganizationMissingPaymentMethod';
  organizationID: Scalars['ID']['output'];
};

export type OrganizationNotFound = {
  __typename?: 'OrganizationNotFound';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationQueryResult = Organization | OrganizationNotFound;

export type OrganizationRenameFailure = {
  __typename?: 'OrganizationRenameFailure';
  result: Scalars['String']['output'];
};

export type OrganizationRenameResult = Organization | OrganizationNotFound | OrganizationRenameFailure;

export type OrganizationSlugInvalid = {
  __typename?: 'OrganizationSlugInvalid';
  slug: Scalars['String']['output'];
};

export type OrganizationSlugOccupied = {
  __typename?: 'OrganizationSlugOccupied';
  slug: Scalars['String']['output'];
};

export type OrganizationTier = {
  __typename?: 'OrganizationTier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unitsCount: Scalars['Decimal']['output'];
};

export type OrganizationTierChangeInput = {
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  organizationSlug: Scalars['String']['input'];
  tierId: Scalars['ID']['input'];
};

export type OrganizationTierChangeResult = Organization | OrganizationNotFound;

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  id: Scalars['ID']['output'];
  status?: Maybe<PaymentAccountStatus>;
};

export type PaymentAccountCreateResult = PaymentAccount | PaymentAccountExists;

export type PaymentAccountDeleteResult = PaymentAccountDeleted | PaymentAccountHasActiveSubscriptions | PaymentAccountNotFound;

export type PaymentAccountDeleted = {
  __typename?: 'PaymentAccountDeleted';
  organizationID: Scalars['ID']['output'];
};

export type PaymentAccountExists = {
  __typename?: 'PaymentAccountExists';
  organizationSlug: Scalars['String']['output'];
  paymentAccount: PaymentAccount;
};

export type PaymentAccountHasActiveSubscriptions = {
  __typename?: 'PaymentAccountHasActiveSubscriptions';
  activeSubscriptionsCount: Scalars['Int']['output'];
  organizationID: Scalars['ID']['output'];
};

export type PaymentAccountNotFound = {
  __typename?: 'PaymentAccountNotFound';
  organizationID: Scalars['ID']['output'];
};

export enum PaymentAccountStatus {
  Restricted = 'RESTRICTED',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

export type PaymentAccountUrl = {
  __typename?: 'PaymentAccountURL';
  url: Scalars['String']['output'];
};

export type PaymentAccountUrlResult = PaymentAccountNotFound | PaymentAccountUrl;

export type PaymentConfiguration = {
  __typename?: 'PaymentConfiguration';
  monthlyPriceUSD: Scalars['Decimal']['output'];
  trialDays?: Maybe<Scalars['Int']['output']>;
};

export type PaymentConfigurationInput = {
  monthlyPriceUSD: Scalars['Decimal']['input'];
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonalAccessTokenAlreadyExists = {
  __typename?: 'PersonalAccessTokenAlreadyExists';
  name: Scalars['String']['output'];
};

export type PersonalAccessTokenCreateInput = {
  description: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
};

export type PersonalAccessTokenCreateResult = PersonalAccessTokenAlreadyExists | PersonalAccessTokenCreated | PersonalAccessTokenInvalidName;

export type PersonalAccessTokenCreated = {
  __typename?: 'PersonalAccessTokenCreated';
  entry: PersonalAccessTokenEntry;
  token: Scalars['String']['output'];
};

export type PersonalAccessTokenEntry = {
  __typename?: 'PersonalAccessTokenEntry';
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PersonalAccessTokenInvalidName = {
  __typename?: 'PersonalAccessTokenInvalidName';
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type PlatformMail = {
  __typename?: 'PlatformMail';
  emailCategory: EmailNotificationCategory;
  sendGridTemplateID: Scalars['String']['output'];
  testMail?: Maybe<Scalars['Boolean']['output']>;
  to: Array<Scalars['String']['output']>;
  userType: Role;
};

export type PlatformMailInput = {
  emailCategory: EmailNotificationCategory;
  sendGridTemplateID: Scalars['String']['input'];
  testMail?: InputMaybe<Scalars['Boolean']['input']>;
  userType: Role;
};

export type PublicTool = {
  __typename?: 'PublicTool';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  developer: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  publicUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  app?: Maybe<App>;
  appSessions: AppSessionConnection;
  appWorkloads: Array<AppDeploymentWorkload>;
  checkVersion: VersionCheckResult;
  collection?: Maybe<CollectionResult>;
  collectionDocument?: Maybe<CollectionDocumentResult>;
  collectionFile?: Maybe<CollectionFileResult>;
  job?: Maybe<Job>;
  jobsByTool: Array<Job>;
  me: User;
  numerousReleases: Array<GithubRepositoryRelease>;
  organization: OrganizationQueryResult;
  organizationById: OrganizationQueryResult;
  organizationInvitation?: Maybe<OrganizationInvitationQueryResult>;
  publicTools?: Maybe<Array<PublicTool>>;
  standingOffer: StandingOfferResult;
  subscription: AppSubscription;
  subscriptionOffer: SubscriptionOfferResult;
  taskInstance?: Maybe<TaskInstance>;
  taskInstances: Array<TaskInstance>;
  tasks: Array<Task>;
  tool: Tool;
  tools: Array<Tool>;
};


export type QueryAppArgs = {
  appSlug: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
};


export type QueryAppSessionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AppSessionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppWorkloadsArgs = {
  appID: Scalars['ID']['input'];
  input?: InputMaybe<AppWorkloadsInput>;
};


export type QueryCheckVersionArgs = {
  version: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobArgs = {
  hashType: ToolHashType;
  toolHash: Scalars['ID']['input'];
};


export type QueryJobsByToolArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type QueryOrganizationByIdArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type QueryStandingOfferArgs = {
  standingOfferId: Scalars['ID']['input'];
};


export type QuerySubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type QuerySubscriptionOfferArgs = {
  subscriptionOfferId: Scalars['ID']['input'];
};


export type QueryTaskInstanceArgs = {
  taskInstanceID: Scalars['ID']['input'];
};


export type QueryTaskInstancesArgs = {
  deployID: Scalars['ID']['input'];
  organizationSlug: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  deployID: Scalars['ID']['input'];
  organizationSlug: Scalars['String']['input'];
};


export type QueryToolArgs = {
  id: Scalars['ID']['input'];
};

export type RequestWhiteLabelAccessMail = {
  __typename?: 'RequestWhiteLabelAccessMail';
  email: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type RequestWhiteLabelAccessMailInput = {
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  whiteLabelId: Scalars['ID']['input'];
};

export type RequestWhiteLabelAccessResult = InvalidEmail | RequestWhiteLabelAccessMail | WhiteLabelConfigNotFound;

export type ResendEmailVerificationResult = ResendEmailVerificationSuccess | UserNotFound;

export type ResendEmailVerificationSuccess = {
  __typename?: 'ResendEmailVerificationSuccess';
  userId: Scalars['ID']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export type StandingOffer = {
  __typename?: 'StandingOffer';
  app: App;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offeringOrganization: Organization;
  payment?: Maybe<PaymentConfiguration>;
  status: StandingOfferStatus;
};

export type StandingOfferAcceptResult = AppSubscription | OrganizationMissingPaymentMethod | SubscriptionAlreadyExists | SubscriptionOfferCheckoutSession | SubscriptionOfferInvalidStatus | SubscriptionOfferNotFound;

export type StandingOfferCreateResult = OfferInvalidMonthlyPriceUsd | OfferInvalidTrialDays | OrganizationHasNoPaymentAccount | StandingOffer;

export type StandingOfferInput = {
  appSlug: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentConfigurationInput>;
};

export type StandingOfferResult = StandingOffer | SubscriptionOfferNotFound;

export enum StandingOfferStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type StopJobPayload = {
  __typename?: 'StopJobPayload';
  message: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  appDeployEvents: AppDeployEvent;
  appDeployLogs: AppDeployLogEntry;
  appSession: AppSessionStarted;
  buildEvents: BuildEvent;
  deployEvents: BuildEvent;
  logs: LogMessage;
  sharedAppSession: AppSessionStarted;
  subscriptionAppSession: AppSessionStarted;
  taskInstanceLogs: WorkloadLogEntry;
};


export type SubscriptionAppDeployEventsArgs = {
  appDeploymentVersionID: Scalars['ID']['input'];
};


export type SubscriptionAppDeployLogsArgs = {
  input: AppDeployLogsInput;
};


export type SubscriptionAppSessionArgs = {
  deployId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type SubscriptionBuildEventsArgs = {
  appPath?: InputMaybe<Scalars['String']['input']>;
  buildId: Scalars['ID']['input'];
};


export type SubscriptionDeployEventsArgs = {
  toolID: Scalars['ID']['input'];
};


export type SubscriptionLogsArgs = {
  appId: Scalars['ID']['input'];
};


export type SubscriptionSharedAppSessionArgs = {
  sessionId: Scalars['ID']['input'];
  sharedUrlId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type SubscriptionSubscriptionAppSessionArgs = {
  sessionId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type SubscriptionTaskInstanceLogsArgs = {
  input: TaskInstanceLogsInput;
};

export type SubscriptionAlreadyExists = {
  __typename?: 'SubscriptionAlreadyExists';
  id: Scalars['ID']['output'];
};

export type SubscriptionOffer = {
  __typename?: 'SubscriptionOffer';
  app: App;
  createdAt: Scalars['Time']['output'];
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  offeringOrganization: Organization;
  payment?: Maybe<PaymentConfiguration>;
  status: SubscriptionOfferStatus;
};

export type SubscriptionOfferAcceptResult = AppSubscription | OrganizationMissingPaymentMethod | SubscriptionOfferCheckoutSession | SubscriptionOfferInvalidStatus | SubscriptionOfferNotFound;

export type SubscriptionOfferCheckoutSession = {
  __typename?: 'SubscriptionOfferCheckoutSession';
  portalURL: Scalars['String']['output'];
};

export type SubscriptionOfferCreateResult = InvalidEmail | OfferInvalidExpiresAt | OfferInvalidMonthlyPriceUsd | OfferInvalidTrialDays | OrganizationHasNoPaymentAccount | SubscriptionOffer;

export type SubscriptionOfferInput = {
  appSlug: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentConfigurationInput>;
};

export type SubscriptionOfferInvalidStatus = {
  __typename?: 'SubscriptionOfferInvalidStatus';
  id: Scalars['ID']['output'];
};

export type SubscriptionOfferNotFound = {
  __typename?: 'SubscriptionOfferNotFound';
  id: Scalars['ID']['output'];
};

export type SubscriptionOfferRejectResult = SubscriptionOffer | SubscriptionOfferInvalidStatus | SubscriptionOfferNotFound;

export type SubscriptionOfferResult = SubscriptionOffer | SubscriptionOfferNotFound;

export enum SubscriptionOfferStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type SubscriptionOfferWithdraw = SubscriptionOffer | SubscriptionOfferInvalidStatus | SubscriptionOfferNotFound;

export type Tag = {
  __typename?: 'Tag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Task = {
  __typename?: 'Task';
  appVersion: AppVersion;
  command: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type TaskInstance = {
  __typename?: 'TaskInstance';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  input?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  progress: TaskInstanceProgress;
  task: Task;
  workload: TaskInstanceWorkload;
};

export type TaskInstanceLogsInput = {
  follow?: InputMaybe<Scalars['Boolean']['input']>;
  tail?: InputMaybe<Scalars['Int']['input']>;
  taskInstanceID: Scalars['ID']['input'];
};

export type TaskInstanceProgress = {
  __typename?: 'TaskInstanceProgress';
  message?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TaskInstanceWorkload = {
  __typename?: 'TaskInstanceWorkload';
  cpuUsage?: Maybe<WorkloadResourceUsage>;
  exitCode?: Maybe<Scalars['Int']['output']>;
  logs: WorkloadLogEntryConnection;
  memoryUsageMB?: Maybe<WorkloadResourceUsage>;
  startedAt: Scalars['Time']['output'];
  status: TaskWorkloadStatus;
};


export type TaskInstanceWorkloadLogsArgs = {
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskStartInput = {
  deployID: Scalars['ID']['input'];
  input?: InputMaybe<Scalars['String']['input']>;
  organizationSlug: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
};

export type TaskStopResult = {
  __typename?: 'TaskStopResult';
  taskInstanceID: Scalars['ID']['output'];
};

export enum TaskWorkloadStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type Tool = {
  __typename?: 'Tool';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  privateUrl?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  sharedUrl?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type ToolDeleteFailure = {
  __typename?: 'ToolDeleteFailure';
  result: Scalars['String']['output'];
};

export type ToolDeleteResult = ToolDeleteFailure | ToolDeleteSuccess;

export type ToolDeleteSuccess = {
  __typename?: 'ToolDeleteSuccess';
  result: Scalars['String']['output'];
};

export enum ToolHashType {
  Private = 'private',
  Public = 'public',
  Shared = 'shared'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  enterprises: Array<Enterprise>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memberships: Array<OrganizationMembership>;
  onboardingStepsCompleted: UserOnboardingStepsCompleted;
  pendingInvitations: Array<OrganizationInvitation>;
  personalAccessTokens: Array<PersonalAccessTokenEntry>;
  preferences: UserPreferences;
};

export type UserDeleted = {
  __typename?: 'UserDeleted';
  id: Scalars['ID']['output'];
};

export type UserHasSoleAdminship = {
  __typename?: 'UserHasSoleAdminship';
  id: Scalars['ID']['output'];
};

export type UserNotFound = {
  __typename?: 'UserNotFound';
  id: Scalars['ID']['output'];
};

export type UserOnboardingStepsCompleted = {
  __typename?: 'UserOnboardingStepsCompleted';
  CreatedApp?: Maybe<Scalars['Boolean']['output']>;
  CreatedSubscriptionOffer?: Maybe<Scalars['Boolean']['output']>;
  InvitedUser?: Maybe<Scalars['Boolean']['output']>;
  UploadedCode?: Maybe<Scalars['Boolean']['output']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  emailNotifications?: Maybe<EmailNotificationPreferences>;
  onboardingDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type VersionCheckCritical = {
  __typename?: 'VersionCheckCritical';
  message: Scalars['String']['output'];
};

export type VersionCheckOk = {
  __typename?: 'VersionCheckOK';
  version: Scalars['String']['output'];
};

export type VersionCheckResult = VersionCheckCritical | VersionCheckOk | VersionCheckWarning | VersionUnknown;

export type VersionCheckWarning = {
  __typename?: 'VersionCheckWarning';
  message: Scalars['String']['output'];
};

export type VersionUnknown = {
  __typename?: 'VersionUnknown';
  version: Scalars['String']['output'];
};

export type WhiteLabelConfigNotFound = {
  __typename?: 'WhiteLabelConfigNotFound';
  id: Scalars['ID']['output'];
};

export type WorkloadLogEntry = {
  __typename?: 'WorkloadLogEntry';
  text: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
};

export type WorkloadLogEntryConnection = {
  __typename?: 'WorkloadLogEntryConnection';
  edges: Array<WorkloadLogEntry>;
  pageInfo: PageInfo;
};

export type WorkloadResourceUsage = {
  __typename?: 'WorkloadResourceUsage';
  current: Scalars['Float']['output'];
  timeseries: Array<WorkloadResourceUsageDataPoint>;
};

export type WorkloadResourceUsageDataPoint = {
  __typename?: 'WorkloadResourceUsageDataPoint';
  timestamp: Scalars['Time']['output'];
  value: Scalars['Float']['output'];
};

export type AppApiKeyRenameResult = AppApiKey | AppApiKeyInvalidName;

export type BuildConfiguration = {
  __typename?: 'buildConfiguration';
  buildId: Scalars['ID']['output'];
};

export type AppSessionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AppSessionsFilterInput>;
}>;


export type AppSessionsQuery = { __typename?: 'Query', appSessions: { __typename: 'AppSessionConnection', edges: Array<{ __typename: 'AppSessionEdge', cursor: string, node: { __typename: 'AppSession', id: string, ownerOrganization: string, userId: string, userEmail?: string | null, accessType: AppSessionAccessType, startTime: Date, endTime?: Date | null, app: { __typename: 'App', id: string, displayName: string } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AppDeploymentApiKeyCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type AppDeploymentApiKeyCreateMutation = { __typename?: 'Mutation', appDeploymentAPIKeyCreate: { __typename: 'AppAPIKey', id: string, name: string, secret: string } | { __typename?: 'AppAPIKeyAlreadyExists' } | { __typename?: 'AppAPIKeyInvalidName' } };

export type AppSubscriptionApiKeyCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type AppSubscriptionApiKeyCreateMutation = { __typename?: 'Mutation', appSubscriptionAPIKeyCreate: { __typename: 'AppAPIKey', id: string, name: string, secret: string } | { __typename?: 'AppAPIKeyAlreadyExists' } | { __typename?: 'AppAPIKeyInvalidName' } };

export type AppApiKeyRevokeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppApiKeyRevokeMutation = { __typename?: 'Mutation', appAPIKeyRevoke: { __typename: 'AppAPIKey', id: string, secret: string } };

export type AppApiKeysQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appSlug: Scalars['String']['input'];
}>;


export type AppApiKeysQuery = { __typename?: 'Query', app?: { __typename: 'App', id: string, defaultDeployment?: { __typename: 'AppDeployment', id: string, apiKeys: Array<{ __typename: 'AppAPIKey', id: string, name: string, secret: string } | null> } | null } | null };

export type ApiKeyFragmentFragment = { __typename: 'AppAPIKey', id: string, name: string, secret: string };

export type SubscriptionAppApiKeysQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type SubscriptionAppApiKeysQuery = { __typename?: 'Query', subscription: { __typename: 'AppSubscription', id: string, apiKeys: Array<{ __typename: 'AppAPIKey', id: string, name: string, secret: string } | null> } };

export type AppDeployShareMutationVariables = Exact<{
  deployID: Scalars['ID']['input'];
}>;


export type AppDeployShareMutation = { __typename?: 'Mutation', appDeployShare: { __typename: 'AppDeployment', id: string, name: string, sharedURL?: string | null, current?: { __typename: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, createdAt: Date } | null } };

export type AppDeployUnshareMutationVariables = Exact<{
  deployID: Scalars['ID']['input'];
}>;


export type AppDeployUnshareMutation = { __typename?: 'Mutation', appDeployUnshare: { __typename: 'AppDeployment', id: string, name: string, sharedURL?: string | null, current?: { __typename: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, createdAt: Date } | null } };

export type AppDescriptionUpdateMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appID: Scalars['ID']['input'];
  appDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type AppDescriptionUpdateMutation = { __typename?: 'Mutation', appDescriptionUpdate?: { __typename: 'App', id: string, description: string } | null };

export type AppRenameMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appID: Scalars['ID']['input'];
  appName: Scalars['String']['input'];
}>;


export type AppRenameMutation = { __typename?: 'Mutation', appRename?: { __typename: 'App', id: string, displayName: string } | null };

export type AppSharedUrlQueryVariables = Exact<{
  appSlug: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
}>;


export type AppSharedUrlQuery = { __typename?: 'Query', app?: { __typename: 'App', id: string, defaultDeployment?: { __typename: 'AppDeployment', id: string, sharedURL?: string | null } | null } | null };

export type Create_Github_App_VersionMutationVariables = Exact<{
  appID: Scalars['ID']['input'];
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
}>;


export type Create_Github_App_VersionMutation = { __typename?: 'Mutation', appVersionCreateGitHub?: { __typename?: 'AppVersion', id: string } | { __typename?: 'GitHubRepositoryNotFound', owner: string, repo: string } | null };

export type Create_AppMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appData: AppCreateInfo;
}>;


export type Create_AppMutation = { __typename?: 'Mutation', appCreate: { __typename?: 'App', id: string, slug: string, displayName: string, description: string, createdAt: Date } };

export type Create_App_VerisonMutationVariables = Exact<{
  appId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type Create_App_VerisonMutation = { __typename?: 'Mutation', appVersionCreate: { __typename?: 'AppVersion', id: string, version: string, message: string } };

export type Read_AppQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appSlug: Scalars['String']['input'];
}>;


export type Read_AppQuery = { __typename?: 'Query', app?: { __typename?: 'App', id: string } | null };

export type Delete_AppMutationVariables = Exact<{
  appSlug: Scalars['String']['input'];
  organizationSlug: Scalars['String']['input'];
}>;


export type Delete_AppMutation = { __typename?: 'Mutation', appDelete: { __typename: 'AppDeleted', appSlug: string, organizationSlug?: string | null } | { __typename: 'AppHasActiveSubscriptions', appSlug: string, activeSubscriptionsCount: number, activeSubscriptionOffersCount: number, activeStandingOffersCount: number } };

export type Deploy_AppMutationVariables = Exact<{
  appVersionID: Scalars['ID']['input'];
  skipMetadataUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type Deploy_AppMutation = { __typename?: 'Mutation', appDeploy: { __typename?: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, appVersion: { __typename?: 'AppVersion', id: string, version: string, message: string } } };

export type AppDeploymentHeartbeatMutationVariables = Exact<{
  deploymentId: Scalars['ID']['input'];
}>;


export type AppDeploymentHeartbeatMutation = { __typename?: 'Mutation', appDeployHeartbeat: { __typename: 'AppDeploymentHeartbeat', status: AppDeploymentStatus, proxyURL?: string | null } };

export type SubscriptionAppDeploymentHeartbeatMutationVariables = Exact<{
  deploymentId: Scalars['ID']['input'];
}>;


export type SubscriptionAppDeploymentHeartbeatMutation = { __typename?: 'Mutation', subscriptionDeployHeartbeat: { __typename: 'AppDeploymentHeartbeat', status: AppDeploymentStatus, proxyURL?: string | null } };

export type SharedAppDeploymentHeartbeatMutationVariables = Exact<{
  deploymentId: Scalars['ID']['input'];
}>;


export type SharedAppDeploymentHeartbeatMutation = { __typename?: 'Mutation', appSharedDeployHeartbeat: { __typename: 'AppDeploymentHeartbeat', status: AppDeploymentStatus, proxyURL?: string | null } };

export type AppQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  appSlug: Scalars['String']['input'];
}>;


export type AppQuery = { __typename?: 'Query', app?: { __typename?: 'App', id: string, defaultDeployment?: { __typename: 'AppDeployment', id: string, current?: { __typename: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, appVersion: { __typename?: 'AppVersion', releaseNotes?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null, userGuide?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null } } | null } | null } | null };

export type DeploymentFragmentFragment = { __typename: 'AppDeployment', id: string, current?: { __typename: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, appVersion: { __typename?: 'AppVersion', releaseNotes?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null, userGuide?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null } } | null };

export type PublicAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicAppsQuery = { __typename?: 'Query', publicTools?: Array<{ __typename: 'PublicTool', id: string, name: string, description?: string | null, pictureUrl?: string | null, publicUrl: string, createdAt: Date, developer: { __typename: 'User', fullName: string } }> | null };

export type Subscription_DeploymentQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type Subscription_DeploymentQuery = { __typename?: 'Query', subscription: { __typename?: 'AppSubscription', app: { __typename: 'App', id: string, defaultDeployment?: { __typename: 'AppDeployment', id: string, current?: { __typename: 'AppDeploymentVersion', id: string, status: AppDeploymentStatus, proxyURL?: string | null, appVersion: { __typename?: 'AppVersion', releaseNotes?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null, userGuide?: { __typename?: 'AppVersionDocumentationFile', filename: string, contentBase64: string } | null } } | null } | null } } };

export type App_Deploy_EventsSubscriptionVariables = Exact<{
  deployVersionID: Scalars['ID']['input'];
}>;


export type App_Deploy_EventsSubscription = { __typename?: 'Subscription', appDeployEvents: { __typename: 'AppBuildErrorEvent', message: string } | { __typename: 'AppBuildMessageEvent', message: string } | { __typename: 'AppDeploymentStatusEvent', status?: AppDeploymentStatus | null } };

export type Create_Upload_UrlMutationVariables = Exact<{
  appVersionId: Scalars['ID']['input'];
}>;


export type Create_Upload_UrlMutation = { __typename?: 'Mutation', appVersionUploadURL: { __typename?: 'AppVersionUploadURL', url: string } };

export type JobQueryVariables = Exact<{
  toolHash: Scalars['ID']['input'];
  hashType: ToolHashType;
}>;


export type JobQuery = { __typename?: 'Query', job?: { __typename: 'Job', id: string, status?: string | null, proxyUrl?: string | null } | null };

export type JobHeartbeatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobHeartbeatMutation = { __typename?: 'Mutation', jobHeartbeat: { __typename: 'JobHeartbeatFailure', result: string } | { __typename: 'JobHeartbeatSuccess', id: string } | { __typename: 'JobNotFound', id: string } };

export type Job_StartMutationVariables = Exact<{
  toolHash: Scalars['ID']['input'];
  hashType: ToolHashType;
}>;


export type Job_StartMutation = { __typename?: 'Mutation', jobStart: { __typename?: 'Job', id: string, proxyUrl?: string | null, status?: string | null } };

export type Get_Organization_AppsQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Get_Organization_AppsQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, name: string, apps: Array<{ __typename: 'App', id: string, slug: string, pictureUrl?: string | null, displayName: string, description: string, createdAt: Date, defaultDeployment?: { __typename: 'AppDeployment', id: string, apiURL?: string | null, apiDocsPath?: string | null, current?: { __typename: 'AppDeploymentVersion', id: string, createdAt: Date } | null } | null, subscription?: { __typename: 'AppSubscription', id: string } | null, createdBy: { __typename?: 'User', fullName: string } }> } | { __typename: 'OrganizationNotFound', id: string } };

export type Get_Organization_Members_And_InvitationsQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Get_Organization_Members_And_InvitationsQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMembership', id: string, role: Role, user: { __typename: 'User', fullName: string, email: string, id: string } }>, pendingInvitations: Array<{ __typename: 'OrganizationInvitation', id: string, invitedAt: Date, email: string, role: Role }> } | { __typename?: 'OrganizationNotFound' } };

export type OrganizationAppSessionsQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationAppSessionsFilterInput>;
}>;


export type OrganizationAppSessionsQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, appSessions: { __typename: 'AppSessionConnection', edges: Array<{ __typename: 'AppSessionEdge', cursor: string, node: { __typename: 'AppSession', id: string, ownerOrganization: string, userId: string, userEmail?: string | null, accessType: AppSessionAccessType, startTime: Date, endTime?: Date | null, app: { __typename: 'App', id: string, displayName: string } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } | { __typename?: 'OrganizationNotFound' } };

export type Organization_CreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  whiteLabelDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type Organization_CreateMutation = { __typename?: 'Mutation', organizationCreate: { __typename: 'Organization', id: string, name: string, slug: string, createdAt: Date, members: Array<{ __typename: 'OrganizationMembership', id: string, role: Role, user: { __typename?: 'User', id: string } }> } | { __typename: 'OrganizationSlugInvalid' } | { __typename: 'OrganizationSlugOccupied' } };

export type OrganizationDeleteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationDeleteMutation = { __typename?: 'Mutation', organizationDelete: { __typename: 'OrganizationDeleted', id: string } | { __typename: 'OrganizationHasApps', id: string } | { __typename: 'OrganizationHasInboundSubscriptions', id: string } | { __typename: 'OrganizationNotFound', id: string } };

export type OrganizationMemberRemoveMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type OrganizationMemberRemoveMutation = { __typename?: 'Mutation', organizationMemberRemove: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMembership', id: string }> } | { __typename: 'OrganizationNotFound', id: string } | { __typename: 'UserNotFound', id: string } };

export type Organization_RenameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type Organization_RenameMutation = { __typename?: 'Mutation', organizationRename: { __typename: 'Organization', id: string, name: string, slug: string } | { __typename: 'OrganizationNotFound', id: string } | { __typename: 'OrganizationRenameFailure', result: string } };

export type Accept_Organization_InvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type Accept_Organization_InvitationMutation = { __typename?: 'Mutation', organizationInvitationAccept?: { __typename: 'Organization', id: string, name: string, slug: string } | { __typename: 'OrganizationNotFound', id: string } | null };

export type Create_Organization_InvitationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  role: Role;
  organizationId: Scalars['ID']['input'];
}>;


export type Create_Organization_InvitationMutation = { __typename?: 'Mutation', organizationInvitationCreate: { __typename: 'InvalidEmail', email: string } | { __typename: 'OrganizationInvitation', id: string, email: string, invitedAt: Date, role: Role } | { __typename: 'OrganizationInvitationExists', email: string } | { __typename: 'OrganizationNotFound', id: string } };

export type Delete_Organization_InvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type Delete_Organization_InvitationMutation = { __typename?: 'Mutation', organizationInvitationDelete?: { __typename?: 'OrganizationInvitationDeleted', id: string } | { __typename?: 'OrganizationInvitationNotFound', id: string } | { __typename?: 'OrganizationNotFound', id: string } | null };

export type Get_Organization_InvitationQueryVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type Get_Organization_InvitationQuery = { __typename?: 'Query', organizationInvitation?: { __typename: 'OrganizationInvitation', id: string, role: Role, email: string, organizationName: string } | { __typename: 'OrganizationInvitationNotFound', id: string } | { __typename: 'OrganizationNotFound', id: string, slug: string } | null };

export type OrganizationInvitationRejectMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type OrganizationInvitationRejectMutation = { __typename?: 'Mutation', organizationInvitationReject?: { __typename: 'OrganizationInvitationNotFound', id: string } | { __typename: 'OrganizationInvitationRejected', id: string } | { __typename: 'OrganizationNotFound' } | null };

export type PendingOrganizationInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingOrganizationInvitationsQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, pendingInvitations: Array<{ __typename: 'OrganizationInvitation', id: string, organizationName: string, invitedAt: Date, role: Role }> } };

export type Create_Payment_AccountMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Create_Payment_AccountMutation = { __typename?: 'Mutation', paymentAccountCreate: { __typename?: 'PaymentAccount', id: string } | { __typename?: 'PaymentAccountExists', organizationSlug: string } };

export type Create_Payment_Account_Onboard_UrlMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Create_Payment_Account_Onboard_UrlMutation = { __typename?: 'Mutation', paymentAccountOnboardURLCreate: { __typename?: 'PaymentAccountNotFound', organizationID: string } | { __typename?: 'PaymentAccountURL', url: string } };

export type Create_Customer_Account_Portal_UrlMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type Create_Customer_Account_Portal_UrlMutation = { __typename?: 'Mutation', customerAccountCreatePortalURL: { __typename?: 'CustomerAccountPortalURL', url: string } };

export type GetPaymentAccountQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type GetPaymentAccountQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, hasCustomerAccount: boolean, paymentAccount?: { __typename?: 'PaymentAccount', status?: PaymentAccountStatus | null, id: string } | null } | { __typename?: 'OrganizationNotFound' } };

export type GetHasCustomerAccountQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type GetHasCustomerAccountQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, hasCustomerAccount: boolean } | { __typename: 'OrganizationNotFound' } };

export type Remove_Payment_ConnectionMutationVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Remove_Payment_ConnectionMutation = { __typename?: 'Mutation', paymentAccountDelete: { __typename: 'PaymentAccountDeleted', organizationID: string } | { __typename: 'PaymentAccountHasActiveSubscriptions', organizationID: string, activeSubscriptionsCount: number } | { __typename: 'PaymentAccountNotFound', organizationID: string } };

export type NumerousReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type NumerousReleasesQuery = { __typename?: 'Query', numerousReleases: Array<{ __typename?: 'GithubRepositoryRelease', id: string, name: string, body: string, publishedAt: Date }> };

export type SendFeedbackMutationVariables = Exact<{
  message: Scalars['String']['input'];
  whiteLabelConfigID?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendFeedback: { __typename: 'FeedbackResult', email: string } };

export type SendPlatformMailMutationVariables = Exact<{
  sendGridTemplateID: Scalars['String']['input'];
  emailCategory: EmailNotificationCategory;
  userType: Role;
  testMail: Scalars['Boolean']['input'];
}>;


export type SendPlatformMailMutation = { __typename?: 'Mutation', sendPlatformMail?: { __typename: 'PlatformMail', testMail?: boolean | null, to: Array<string> } | null };

export type StandingOfferQueryVariables = Exact<{
  standingOfferId: Scalars['ID']['input'];
}>;


export type StandingOfferQuery = { __typename?: 'Query', standingOffer: { __typename: 'StandingOffer', id: string, name: string, message: string, status: StandingOfferStatus, app: { __typename: 'App', id: string, displayName: string, description: string, slug: string, pictureUrl?: string | null }, offeringOrganization: { __typename: 'Organization', id: string, name: string }, payment?: { __typename: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type StandingOfferAcceptMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  standingOfferId: Scalars['ID']['input'];
}>;


export type StandingOfferAcceptMutation = { __typename?: 'Mutation', standingOfferAccept: { __typename: 'AppSubscription', id: string, app: { __typename: 'App', displayName: string }, inboundOrganization: { __typename: 'Organization', slug: string } } | { __typename: 'OrganizationMissingPaymentMethod', organizationID: string } | { __typename: 'SubscriptionAlreadyExists', id: string } | { __typename: 'SubscriptionOfferCheckoutSession', portalURL: string } | { __typename: 'SubscriptionOfferInvalidStatus', id: string } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type StandingOfferCancelMutationVariables = Exact<{
  standingOfferId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type StandingOfferCancelMutation = { __typename?: 'Mutation', standingOfferCancel: { __typename: 'StandingOffer', id: string, status: StandingOfferStatus } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type StandingOfferCreateMutationVariables = Exact<{
  input: StandingOfferInput;
  organizationId: Scalars['ID']['input'];
}>;


export type StandingOfferCreateMutation = { __typename?: 'Mutation', standingOfferCreate: { __typename: 'OfferInvalidMonthlyPriceUSD', monthlyPriceUSD: string } | { __typename: 'OfferInvalidTrialDays', trialDays: number, maxTrialDays: number } | { __typename: 'OrganizationHasNoPaymentAccount', organizationID: string } | { __typename: 'StandingOffer', id: string, name: string, message: string, createdAt: Date, status: StandingOfferStatus, app: { __typename: 'App', id: string, slug: string, displayName: string, description: string }, offeringOrganization: { __typename: 'Organization', id: string, name: string, slug: string }, payment?: { __typename: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null } };

export type StandingOffersQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type StandingOffersQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, standingOffers: Array<{ __typename: 'StandingOffer', id: string, name: string, message: string, createdAt: Date, status: StandingOfferStatus, app: { __typename: 'App', id: string, displayName: string, pictureUrl?: string | null }, payment?: { __typename: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null }> } | { __typename?: 'OrganizationNotFound' } };

export type Cancel_Inbound_SubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type Cancel_Inbound_SubscriptionMutation = { __typename?: 'Mutation', subscriptionCancelInbound: { __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, inboundOrganization: { __typename?: 'Organization', id: string, slug: string } } | { __typename: 'AppSubscriptionInvalidStatus', id: string } | { __typename: 'AppSubscriptionNotFound', id: string } };

export type SubscriptionOrganizationFragment = { __typename: 'Organization', id: string, name: string };

export type AppSubscriptionsFragment = { __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, createdAt: Date, expiresAt?: Date | null, monthlyPriceUSD?: string | null, name?: string | null, outboundOrganization: { __typename: 'Organization', id: string, name: string }, inboundOrganization: { __typename: 'Organization', id: string, name: string }, app: { __typename: 'App', id: string, displayName: string, description: string, pictureUrl?: string | null } };

type AppSubscriptionCancel_AppSubscription_Fragment = { __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, inboundOrganization: { __typename?: 'Organization', id: string, slug: string } };

type AppSubscriptionCancel_AppSubscriptionInvalidStatus_Fragment = { __typename: 'AppSubscriptionInvalidStatus', id: string };

type AppSubscriptionCancel_AppSubscriptionNotFound_Fragment = { __typename: 'AppSubscriptionNotFound', id: string };

export type AppSubscriptionCancelFragment = AppSubscriptionCancel_AppSubscription_Fragment | AppSubscriptionCancel_AppSubscriptionInvalidStatus_Fragment | AppSubscriptionCancel_AppSubscriptionNotFound_Fragment;

export type InboundSubscriptionsQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type InboundSubscriptionsQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, apps: Array<{ __typename: 'App', subscription?: { __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, createdAt: Date, expiresAt?: Date | null, monthlyPriceUSD?: string | null, name?: string | null, outboundOrganization: { __typename: 'Organization', id: string, name: string }, inboundOrganization: { __typename: 'Organization', id: string, name: string }, app: { __typename: 'App', id: string, displayName: string, description: string, pictureUrl?: string | null } } | null }> } | { __typename?: 'OrganizationNotFound' } };

export type OutboundSubscriptionsQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type OutboundSubscriptionsQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, outboundSubscriptions: Array<{ __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, createdAt: Date, expiresAt?: Date | null, monthlyPriceUSD?: string | null, name?: string | null, outboundOrganization: { __typename: 'Organization', id: string, name: string }, inboundOrganization: { __typename: 'Organization', id: string, name: string }, app: { __typename: 'App', id: string, displayName: string, description: string, pictureUrl?: string | null } }> } | { __typename?: 'OrganizationNotFound' } };

export type Withdraw_Outbound_SubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type Withdraw_Outbound_SubscriptionMutation = { __typename?: 'Mutation', subscriptionCancelOutbound: { __typename: 'AppSubscription', id: string, status: AppSubscriptionStatus, inboundOrganization: { __typename?: 'Organization', id: string, slug: string } } | { __typename: 'AppSubscriptionInvalidStatus', id: string } | { __typename: 'AppSubscriptionNotFound', id: string } };

export type SubscriptionOfferQueryVariables = Exact<{
  subscriptionOfferId: Scalars['ID']['input'];
}>;


export type SubscriptionOfferQuery = { __typename?: 'Query', subscriptionOffer: { __typename: 'SubscriptionOffer', id: string, message: string, status: SubscriptionOfferStatus, expiresAt?: Date | null, payment?: { __typename?: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null, app: { __typename: 'App', id: string, slug: string, displayName: string, description: string }, offeringOrganization: { __typename: 'Organization', id: string, name: string } } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type SubscriptionOffersQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type SubscriptionOffersQuery = { __typename?: 'Query', organization: { __typename: 'Organization', id: string, outboundSubscriptionOffers: Array<{ __typename: 'SubscriptionOffer', id: string, email: string, status: SubscriptionOfferStatus, name: string, createdAt: Date, expiresAt?: Date | null, payment?: { __typename: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null, app: { __typename: 'App', id: string, displayName: string, pictureUrl?: string | null } }> } | { __typename?: 'OrganizationNotFound' } };

export type SubscriptionOfferAcceptMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  subscriptionOfferId: Scalars['ID']['input'];
}>;


export type SubscriptionOfferAcceptMutation = { __typename?: 'Mutation', subscriptionOfferAccept: { __typename: 'AppSubscription', id: string, app: { __typename: 'App', displayName: string }, inboundOrganization: { __typename: 'Organization', slug: string } } | { __typename: 'OrganizationMissingPaymentMethod', organizationID: string } | { __typename: 'SubscriptionOfferCheckoutSession', portalURL: string } | { __typename: 'SubscriptionOfferInvalidStatus', id: string } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type SubscriptionOfferCreateMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  appSlug: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  payment?: InputMaybe<PaymentConfigurationInput>;
}>;


export type SubscriptionOfferCreateMutation = { __typename?: 'Mutation', subscriptionOfferCreate: { __typename: 'InvalidEmail', email: string } | { __typename: 'OfferInvalidExpiresAt', expiresAt: Date } | { __typename: 'OfferInvalidMonthlyPriceUSD', monthlyPriceUSD: string } | { __typename: 'OfferInvalidTrialDays', trialDays: number } | { __typename?: 'OrganizationHasNoPaymentAccount' } | { __typename: 'SubscriptionOffer', id: string, email: string, status: SubscriptionOfferStatus, name: string, createdAt: Date, payment?: { __typename: 'PaymentConfiguration', monthlyPriceUSD: string, trialDays?: number | null } | null, app: { __typename: 'App', id: string, displayName: string, pictureUrl?: string | null } } };

export type SubscriptionOfferRejectMutationVariables = Exact<{
  subscriptionOfferId: Scalars['ID']['input'];
}>;


export type SubscriptionOfferRejectMutation = { __typename?: 'Mutation', subscriptionOfferReject: { __typename: 'SubscriptionOffer', id: string } | { __typename: 'SubscriptionOfferInvalidStatus', id: string } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type SubscriptionOfferWithdrawMutationVariables = Exact<{
  subscriptionOfferId: Scalars['ID']['input'];
}>;


export type SubscriptionOfferWithdrawMutation = { __typename?: 'Mutation', subscriptionOfferWithdraw: { __typename: 'SubscriptionOffer', id: string, status: SubscriptionOfferStatus } | { __typename: 'SubscriptionOfferInvalidStatus', id: string } | { __typename: 'SubscriptionOfferNotFound', id: string } };

export type GetActiveUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveUserQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, fullName: string, email: string } };

export type UserMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMembershipsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, memberships: Array<{ __typename?: 'OrganizationMembership', id: string, role: Role, organization: { __typename?: 'Organization', id: string, name: string, slug: string, createdAt: Date } }> } };

export type MeDeleteMutationVariables = Exact<{ [key: string]: never; }>;


export type MeDeleteMutation = { __typename?: 'Mutation', meDelete: { __typename: 'UserDeleted', id: string } | { __typename: 'UserHasSoleAdminship', id: string } | { __typename: 'UserNotFound', id: string } };

export type OnboardingStepsCompletedQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingStepsCompletedQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, onboardingStepsCompleted: { __typename: 'UserOnboardingStepsCompleted', CreatedApp?: boolean | null, UploadedCode?: boolean | null, InvitedUser?: boolean | null, CreatedSubscriptionOffer?: boolean | null } } };

export type ResendEmailVerificationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', resendEmailVerification: { __typename: 'ResendEmailVerificationSuccess', userId: string } | { __typename: 'UserNotFound', id: string } };

export type Update_User_RoleMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: Role;
}>;


export type Update_User_RoleMutation = { __typename?: 'Mutation', organizationMemberEditRole: { __typename?: 'OrganizationMembership', id: string, role: Role } | { __typename?: 'OrganizationNotFound', id: string } | { __typename?: 'UserNotFound', id: string } };

export type Get_Active_OrganizationQueryVariables = Exact<{
  organizationSlug: Scalars['String']['input'];
}>;


export type Get_Active_OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, slug: string } | { __typename?: 'OrganizationNotFound', id: string, slug: string } };

export type Get_User_RoleQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_User_RoleQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, memberships: Array<{ __typename?: 'OrganizationMembership', role: Role, organization: { __typename?: 'Organization', id: string, slug: string } }> } };

export type UserEmailNotificationPreferenceUpdateMutationVariables = Exact<{
  emailCategory: EmailNotificationCategory;
  value: Scalars['Boolean']['input'];
}>;


export type UserEmailNotificationPreferenceUpdateMutation = { __typename?: 'Mutation', userEmailNotificationPreferenceUpdate: { __typename: 'User', id: string, preferences: { __typename: 'UserPreferences', emailNotifications?: { __typename: 'EmailNotificationPreferences', MarketingDisabled?: boolean | null, ReleaseNotesDisabled?: boolean | null, OnboardingDisabled?: boolean | null, OrganizationUpdatesDisabled?: boolean | null, DeploymentUpdatesDisabled?: boolean | null } | null } } };

export type UserEmailNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEmailNotificationPreferencesQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, preferences: { __typename: 'UserPreferences', emailNotifications?: { __typename: 'EmailNotificationPreferences', MarketingDisabled?: boolean | null, ReleaseNotesDisabled?: boolean | null, OnboardingDisabled?: boolean | null, OrganizationUpdatesDisabled?: boolean | null, DeploymentUpdatesDisabled?: boolean | null } | null } } };

export type UserOnboardingDisableMutationVariables = Exact<{ [key: string]: never; }>;


export type UserOnboardingDisableMutation = { __typename?: 'Mutation', userOnboardingDisable: { __typename: 'User', id: string, preferences: { __typename: 'UserPreferences', onboardingDisabled?: boolean | null } } };

export type UserOnboardingEnableMutationVariables = Exact<{ [key: string]: never; }>;


export type UserOnboardingEnableMutation = { __typename?: 'Mutation', userOnboardingEnable: { __typename: 'User', id: string, preferences: { __typename: 'UserPreferences', onboardingDisabled?: boolean | null } } };

export type UserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPreferencesQuery = { __typename?: 'Query', me: { __typename: 'User', id: string, preferences: { __typename: 'UserPreferences', onboardingDisabled?: boolean | null } } };

export type UserRenameMutationVariables = Exact<{
  fullName: Scalars['String']['input'];
}>;


export type UserRenameMutation = { __typename?: 'Mutation', userRename?: { __typename: 'User', id: string, fullName: string } | null };

export type SendRequestWhiteLabelAccessMutationVariables = Exact<{
  whiteLabelId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendRequestWhiteLabelAccessMutation = { __typename?: 'Mutation', sendRequestWhiteLabelAccessMail: { __typename: 'InvalidEmail', email: string } | { __typename: 'RequestWhiteLabelAccessMail', email: string, message?: string | null } | { __typename: 'WhiteLabelConfigNotFound', id: string } };

export type App_SessionSubscriptionVariables = Exact<{
  deployId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type App_SessionSubscription = { __typename?: 'Subscription', appSession: { __typename?: 'AppSessionStarted', sessionId: string } };

export type Subscription_App_SessionSubscriptionVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
}>;


export type Subscription_App_SessionSubscription = { __typename?: 'Subscription', subscriptionAppSession: { __typename?: 'AppSessionStarted', sessionId: string } };

export type Shared_App_SessionSubscriptionVariables = Exact<{
  sharedUrlId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type Shared_App_SessionSubscription = { __typename?: 'Subscription', sharedAppSession: { __typename?: 'AppSessionStarted', sessionId: string } };

export const ApiKeyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"APIKeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppAPIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]} as unknown as DocumentNode<ApiKeyFragmentFragment, unknown>;
export const DeploymentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeploymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppDeployment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGuide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeploymentFragmentFragment, unknown>;
export const SubscriptionOrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SubscriptionOrganizationFragment, unknown>;
export const AppSubscriptionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"outboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<AppSubscriptionsFragment, unknown>;
export const AppSubscriptionCancelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptionCancel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionCancelResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AppSubscriptionCancelFragment, unknown>;
export const AppSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AppSessionsFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<AppSessionsQuery, AppSessionsQueryVariables>;
export const AppDeploymentApiKeyCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appDeploymentAPIKeyCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeploymentAPIKeyCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deployID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"APIKeyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"APIKeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppAPIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]} as unknown as DocumentNode<AppDeploymentApiKeyCreateMutation, AppDeploymentApiKeyCreateMutationVariables>;
export const AppSubscriptionApiKeyCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appSubscriptionAPIKeyCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSubscriptionAPIKeyCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"APIKeyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"APIKeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppAPIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]} as unknown as DocumentNode<AppSubscriptionApiKeyCreateMutation, AppSubscriptionApiKeyCreateMutationVariables>;
export const AppApiKeyRevokeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appAPIKeyRevoke"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appAPIKeyRevoke"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]} as unknown as DocumentNode<AppApiKeyRevokeMutation, AppApiKeyRevokeMutationVariables>;
export const AppApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appAPIKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"APIKeyFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"APIKeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppAPIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]} as unknown as DocumentNode<AppApiKeysQuery, AppApiKeysQueryVariables>;
export const SubscriptionAppApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionAppAPIKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"APIKeyFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"APIKeyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppAPIKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]} as unknown as DocumentNode<SubscriptionAppApiKeysQuery, SubscriptionAppApiKeysQueryVariables>;
export const AppDeployShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appDeployShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deployID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeployShare"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deployID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deployID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sharedURL"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<AppDeployShareMutation, AppDeployShareMutationVariables>;
export const AppDeployUnshareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appDeployUnshare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deployID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeployUnshare"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deployID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deployID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sharedURL"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<AppDeployUnshareMutation, AppDeployUnshareMutationVariables>;
export const AppDescriptionUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appDescriptionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDescriptionUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appDescription"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AppDescriptionUpdateMutation, AppDescriptionUpdateMutationVariables>;
export const AppRenameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appRename"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appRename"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appData"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<AppRenameMutation, AppRenameMutationVariables>;
export const AppSharedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appSharedURL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sharedURL"}}]}}]}}]}}]} as unknown as DocumentNode<AppSharedUrlQuery, AppSharedUrlQueryVariables>;
export const Create_Github_App_VersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_GITHUB_APP_VERSION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appVersionCreateGitHub"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"repo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repo"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppVersion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GitHubRepositoryNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"repo"}}]}}]}}]}}]} as unknown as DocumentNode<Create_Github_App_VersionMutation, Create_Github_App_VersionMutationVariables>;
export const Create_AppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_APP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppCreateInfo"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<Create_AppMutation, Create_AppMutationVariables>;
export const Create_App_VerisonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_APP_VERISON"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appVersionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<Create_App_VerisonMutation, Create_App_VerisonMutationVariables>;
export const Read_AppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"READ_APP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"App"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Read_AppQuery, Read_AppQueryVariables>;
export const Delete_AppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_APP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSlug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationSlug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppHasActiveSubscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSlug"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptionOffersCount"}},{"kind":"Field","name":{"kind":"Name","value":"activeStandingOffersCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<Delete_AppMutation, Delete_AppMutationVariables>;
export const Deploy_AppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DEPLOY_APP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appVersionID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipMetadataUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeploy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appVersionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appVersionID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"skipMetadataUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMetadataUpdate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<Deploy_AppMutation, Deploy_AppMutationVariables>;
export const AppDeploymentHeartbeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appDeploymentHeartbeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeployHeartbeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deployID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}}]}}]}}]} as unknown as DocumentNode<AppDeploymentHeartbeatMutation, AppDeploymentHeartbeatMutationVariables>;
export const SubscriptionAppDeploymentHeartbeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscriptionAppDeploymentHeartbeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionDeployHeartbeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}}]}}]}}]} as unknown as DocumentNode<SubscriptionAppDeploymentHeartbeatMutation, SubscriptionAppDeploymentHeartbeatMutationVariables>;
export const SharedAppDeploymentHeartbeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sharedAppDeploymentHeartbeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSharedDeployHeartbeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sharedURLID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}}]}}]}}]} as unknown as DocumentNode<SharedAppDeploymentHeartbeatMutation, SharedAppDeploymentHeartbeatMutationVariables>;
export const AppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"APP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}},{"kind":"Argument","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"App"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeploymentFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeploymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppDeployment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGuide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppQuery, AppQueryVariables>;
export const PublicAppsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publicApps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<PublicAppsQuery, PublicAppsQueryVariables>;
export const Subscription_DeploymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SUBSCRIPTION_DEPLOYMENT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeploymentFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeploymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppDeployment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyURL"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"releaseNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGuide"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"contentBase64"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Subscription_DeploymentQuery, Subscription_DeploymentQueryVariables>;
export const App_Deploy_EventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"APP_DEPLOY_EVENTS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deployVersionID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appDeployEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appDeploymentVersionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deployVersionID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppBuildMessageEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppDeploymentStatusEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppBuildErrorEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<App_Deploy_EventsSubscription, App_Deploy_EventsSubscriptionVariables>;
export const Create_Upload_UrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_UPLOAD_URL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appVersionUploadURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appVersionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Create_Upload_UrlMutation, Create_Upload_UrlMutationVariables>;
export const JobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JOB"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toolHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hashType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToolHashType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"toolHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toolHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"hashType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hashType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"proxyUrl"}}]}}]}}]} as unknown as DocumentNode<JobQuery, JobQueryVariables>;
export const JobHeartbeatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobHeartbeat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobHeartbeat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobHeartbeatSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobHeartbeatFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JobHeartbeatMutation, JobHeartbeatMutationVariables>;
export const Job_StartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JOB_START"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toolHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hashType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToolHashType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobStart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"toolHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toolHash"}}},{"kind":"Argument","name":{"kind":"Name","value":"hashType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hashType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proxyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<Job_StartMutation, Job_StartMutationVariables>;
export const Get_Organization_AppsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ORGANIZATION_APPS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDeployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apiURL"}},{"kind":"Field","name":{"kind":"Name","value":"apiDocsPath"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Organization_AppsQuery, Get_Organization_AppsQueryVariables>;
export const Get_Organization_Members_And_InvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ORGANIZATION_MEMBERS_AND_INVITATIONS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Get_Organization_Members_And_InvitationsQuery, Get_Organization_Members_And_InvitationsQueryVariables>;
export const OrganizationAppSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationAppSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAppSessionsFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"accessType"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationAppSessionsQuery, OrganizationAppSessionsQueryVariables>;
export const Organization_CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ORGANIZATION_CREATE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"whiteLabelDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelDomain"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<Organization_CreateMutation, Organization_CreateMutationVariables>;
export const OrganizationDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organizationDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationHasApps"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationHasInboundSubscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationDeleteMutation, OrganizationDeleteMutationVariables>;
export const OrganizationMemberRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organizationMemberRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMemberRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationMemberRemoveMutation, OrganizationMemberRemoveMutationVariables>;
export const Organization_RenameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ORGANIZATION_RENAME"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationRename"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationRenameFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]}}]} as unknown as DocumentNode<Organization_RenameMutation, Organization_RenameMutationVariables>;
export const Accept_Organization_InvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ACCEPT_ORGANIZATION_INVITATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvitationAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Accept_Organization_InvitationMutation, Accept_Organization_InvitationMutationVariables>;
export const Create_Organization_InvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_ORGANIZATION_INVITATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvitationCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEmail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<Create_Organization_InvitationMutation, Create_Organization_InvitationMutationVariables>;
export const Delete_Organization_InvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DELETE_ORGANIZATION_INVITATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvitationDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Delete_Organization_InvitationMutation, Delete_Organization_InvitationMutationVariables>;
export const Get_Organization_InvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ORGANIZATION_INVITATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Organization_InvitationQuery, Get_Organization_InvitationQueryVariables>;
export const OrganizationInvitationRejectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"organizationInvitationReject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvitationReject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationRejected"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationInvitationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationInvitationRejectMutation, OrganizationInvitationRejectMutationVariables>;
export const PendingOrganizationInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pendingOrganizationInvitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"invitedAt"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<PendingOrganizationInvitationsQuery, PendingOrganizationInvitationsQueryVariables>;
export const Create_Payment_AccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_PAYMENT_ACCOUNT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentAccountCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSlug"}}]}}]}}]}}]} as unknown as DocumentNode<Create_Payment_AccountMutation, Create_Payment_AccountMutationVariables>;
export const Create_Payment_Account_Onboard_UrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_PAYMENT_ACCOUNT_ONBOARD_URL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentAccountOnboardURLCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountURL"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}}]}}]}}]} as unknown as DocumentNode<Create_Payment_Account_Onboard_UrlMutation, Create_Payment_Account_Onboard_UrlMutationVariables>;
export const Create_Customer_Account_Portal_UrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_CUSTOMER_ACCOUNT_PORTAL_URL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAccountCreatePortalURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<Create_Customer_Account_Portal_UrlMutation, Create_Customer_Account_Portal_UrlMutationVariables>;
export const GetPaymentAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPaymentAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomerAccount"}}]}}]}}]}}]} as unknown as DocumentNode<GetPaymentAccountQuery, GetPaymentAccountQueryVariables>;
export const GetHasCustomerAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHasCustomerAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomerAccount"}}]}}]}}]}}]} as unknown as DocumentNode<GetHasCustomerAccountQuery, GetHasCustomerAccountQueryVariables>;
export const Remove_Payment_ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"REMOVE_PAYMENT_CONNECTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentAccountDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentAccountHasActiveSubscriptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationID"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptionsCount"}}]}}]}}]}}]} as unknown as DocumentNode<Remove_Payment_ConnectionMutation, Remove_Payment_ConnectionMutationVariables>;
export const NumerousReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"numerousReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numerousReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]} as unknown as DocumentNode<NumerousReleasesQuery, NumerousReleasesQueryVariables>;
export const SendFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelConfigID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"whiteLabelConfigID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelConfigID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<SendFeedbackMutation, SendFeedbackMutationVariables>;
export const SendPlatformMailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendPlatformMail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendGridTemplateID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"testMail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPlatformMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sendGridTemplateID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendGridTemplateID"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailCategory"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"testMail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"testMail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"testMail"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]} as unknown as DocumentNode<SendPlatformMailMutation, SendPlatformMailMutationVariables>;
export const StandingOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"standingOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standingOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"standingOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandingOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offeringOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<StandingOfferQuery, StandingOfferQueryVariables>;
export const StandingOfferAcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"standingOfferAccept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standingOfferAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"standingOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferCheckoutSession"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"portalURL"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationMissingPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionAlreadyExists"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<StandingOfferAcceptMutation, StandingOfferAcceptMutationVariables>;
export const StandingOfferCancelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"standingOfferCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standingOfferCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"standingOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"standingOfferId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandingOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<StandingOfferCancelMutation, StandingOfferCancelMutationVariables>;
export const StandingOfferCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"standingOfferCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StandingOfferInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standingOfferCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StandingOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offeringOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationHasNoPaymentAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInvalidMonthlyPriceUSD"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInvalidTrialDays"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}},{"kind":"Field","name":{"kind":"Name","value":"maxTrialDays"}}]}}]}}]}}]} as unknown as DocumentNode<StandingOfferCreateMutation, StandingOfferCreateMutationVariables>;
export const StandingOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"standingOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standingOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StandingOffersQuery, StandingOffersQueryVariables>;
export const Cancel_Inbound_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CANCEL_INBOUND_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionCancelInbound"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppSubscriptionCancel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptionCancel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionCancelResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Cancel_Inbound_SubscriptionMutation, Cancel_Inbound_SubscriptionMutationVariables>;
export const InboundSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InboundSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppSubscriptions"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"outboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}}]} as unknown as DocumentNode<InboundSubscriptionsQuery, InboundSubscriptionsQueryVariables>;
export const OutboundSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OutboundSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outboundSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppSubscriptions"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"outboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOrganization"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}}]} as unknown as DocumentNode<OutboundSubscriptionsQuery, OutboundSubscriptionsQueryVariables>;
export const Withdraw_Outbound_SubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WITHDRAW_OUTBOUND_SUBSCRIPTION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionCancelOutbound"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppSubscriptionCancel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppSubscriptionCancel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionCancelResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Withdraw_Outbound_SubscriptionMutation, Withdraw_Outbound_SubscriptionMutationVariables>;
export const SubscriptionOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offeringOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferQuery, SubscriptionOfferQueryVariables>;
export const SubscriptionOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"outboundSubscriptionOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOffersQuery, SubscriptionOffersQueryVariables>;
export const SubscriptionOfferAcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscriptionOfferAccept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionOfferAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscriptionOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferCheckoutSession"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"portalURL"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationMissingPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"organizationID"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferAcceptMutation, SubscriptionOfferAcceptMutationVariables>;
export const SubscriptionOfferCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscriptionOfferCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentConfigurationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionOfferCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appSlug"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiresAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"pictureUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEmail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInvalidExpiresAt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInvalidMonthlyPriceUSD"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPriceUSD"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInvalidTrialDays"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferCreateMutation, SubscriptionOfferCreateMutationVariables>;
export const SubscriptionOfferRejectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscriptionOfferReject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionOfferReject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferRejectMutation, SubscriptionOfferRejectMutationVariables>;
export const SubscriptionOfferWithdrawDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscriptionOfferWithdraw"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionOfferWithdraw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionOfferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionOfferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionOfferInvalidStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionOfferWithdrawMutation, SubscriptionOfferWithdrawMutationVariables>;
export const GetActiveUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetActiveUserQuery, GetActiveUserQueryVariables>;
export const UserMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserMembershipsQuery, UserMembershipsQueryVariables>;
export const MeDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"meDelete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meDelete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserHasSoleAdminship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MeDeleteMutation, MeDeleteMutationVariables>;
export const OnboardingStepsCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"onboardingStepsCompleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStepsCompleted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedApp"}},{"kind":"Field","name":{"kind":"Name","value":"UploadedCode"}},{"kind":"Field","name":{"kind":"Name","value":"InvitedUser"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedSubscriptionOffer"}}]}}]}}]}}]} as unknown as DocumentNode<OnboardingStepsCompletedQuery, OnboardingStepsCompletedQueryVariables>;
export const ResendEmailVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendEmailVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendEmailVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResendEmailVerificationSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const Update_User_RoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_USER_ROLE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMemberEditRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<Update_User_RoleMutation, Update_User_RoleMutationVariables>;
export const Get_Active_OrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ACTIVE_ORGANIZATION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSlug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Active_OrganizationQuery, Get_Active_OrganizationQueryVariables>;
export const Get_User_RoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_USER_ROLE"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Get_User_RoleQuery, Get_User_RoleQueryVariables>;
export const UserEmailNotificationPreferenceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userEmailNotificationPreferenceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailNotificationCategory"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userEmailNotificationPreferenceUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"emailCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"emailNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"MarketingDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"ReleaseNotesDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"OnboardingDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"OrganizationUpdatesDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"DeploymentUpdatesDisabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserEmailNotificationPreferenceUpdateMutation, UserEmailNotificationPreferenceUpdateMutationVariables>;
export const UserEmailNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userEmailNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"emailNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"MarketingDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"ReleaseNotesDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"OnboardingDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"OrganizationUpdatesDisabled"}},{"kind":"Field","name":{"kind":"Name","value":"DeploymentUpdatesDisabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserEmailNotificationPreferencesQuery, UserEmailNotificationPreferencesQueryVariables>;
export const UserOnboardingDisableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userOnboardingDisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOnboardingDisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingDisabled"}}]}}]}}]}}]} as unknown as DocumentNode<UserOnboardingDisableMutation, UserOnboardingDisableMutationVariables>;
export const UserOnboardingEnableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userOnboardingEnable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOnboardingEnable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingDisabled"}}]}}]}}]}}]} as unknown as DocumentNode<UserOnboardingEnableMutation, UserOnboardingEnableMutationVariables>;
export const UserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingDisabled"}}]}}]}}]}}]} as unknown as DocumentNode<UserPreferencesQuery, UserPreferencesQueryVariables>;
export const UserRenameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userRename"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRename"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<UserRenameMutation, UserRenameMutationVariables>;
export const SendRequestWhiteLabelAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendRequestWhiteLabelAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendRequestWhiteLabelAccessMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"whiteLabelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whiteLabelId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RequestWhiteLabelAccessMail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEmail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhiteLabelConfigNotFound"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SendRequestWhiteLabelAccessMutation, SendRequestWhiteLabelAccessMutationVariables>;
export const App_SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"APP_SESSION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deployId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deployId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deployId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]} as unknown as DocumentNode<App_SessionSubscription, App_SessionSubscriptionVariables>;
export const Subscription_App_SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SUBSCRIPTION_APP_SESSION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionAppSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]} as unknown as DocumentNode<Subscription_App_SessionSubscription, Subscription_App_SessionSubscriptionVariables>;
export const Shared_App_SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"SHARED_APP_SESSION"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedUrlId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedAppSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sharedUrlId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedUrlId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]} as unknown as DocumentNode<Shared_App_SessionSubscription, Shared_App_SessionSubscriptionVariables>;
export type AppKeySpecifier = ('createdAt' | 'createdBy' | 'defaultDeployment' | 'description' | 'displayName' | 'id' | 'pictureUrl' | 'slug' | 'subscription' | AppKeySpecifier)[];
export type AppFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDeployment?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	pictureUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppAPIKeyKeySpecifier = ('id' | 'name' | 'secret' | AppAPIKeyKeySpecifier)[];
export type AppAPIKeyFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	secret?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppAPIKeyAlreadyExistsKeySpecifier = ('name' | AppAPIKeyAlreadyExistsKeySpecifier)[];
export type AppAPIKeyAlreadyExistsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppAPIKeyInvalidNameKeySpecifier = ('name' | 'reason' | AppAPIKeyInvalidNameKeySpecifier)[];
export type AppAPIKeyInvalidNameFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppBuildErrorEventKeySpecifier = ('message' | AppBuildErrorEventKeySpecifier)[];
export type AppBuildErrorEventFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppBuildMessageEventKeySpecifier = ('message' | AppBuildMessageEventKeySpecifier)[];
export type AppBuildMessageEventFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeletedKeySpecifier = ('appSlug' | 'organizationSlug' | AppDeletedKeySpecifier)[];
export type AppDeletedFieldPolicy = {
	appSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeployLogEntryKeySpecifier = ('text' | 'timestamp' | AppDeployLogEntryKeySpecifier)[];
export type AppDeployLogEntryFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeployLogEntryConnectionKeySpecifier = ('edges' | 'pageInfo' | AppDeployLogEntryConnectionKeySpecifier)[];
export type AppDeployLogEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentKeySpecifier = ('apiDocsPath' | 'apiKeys' | 'apiURL' | 'current' | 'id' | 'name' | 'sharedURL' | AppDeploymentKeySpecifier)[];
export type AppDeploymentFieldPolicy = {
	apiDocsPath?: FieldPolicy<any> | FieldReadFunction<any>,
	apiKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	apiURL?: FieldPolicy<any> | FieldReadFunction<any>,
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentHeartbeatKeySpecifier = ('proxyURL' | 'status' | AppDeploymentHeartbeatKeySpecifier)[];
export type AppDeploymentHeartbeatFieldPolicy = {
	proxyURL?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentResourceUsageKeySpecifier = ('current' | 'limit' | 'timeseries' | AppDeploymentResourceUsageKeySpecifier)[];
export type AppDeploymentResourceUsageFieldPolicy = {
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	limit?: FieldPolicy<any> | FieldReadFunction<any>,
	timeseries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentResourceUsageDataPointKeySpecifier = ('timestamp' | 'value' | AppDeploymentResourceUsageDataPointKeySpecifier)[];
export type AppDeploymentResourceUsageDataPointFieldPolicy = {
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentStatusEventKeySpecifier = ('status' | AppDeploymentStatusEventKeySpecifier)[];
export type AppDeploymentStatusEventFieldPolicy = {
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentVersionKeySpecifier = ('appVersion' | 'createdAt' | 'id' | 'proxyURL' | 'status' | AppDeploymentVersionKeySpecifier)[];
export type AppDeploymentVersionFieldPolicy = {
	appVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	proxyURL?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeploymentWorkloadKeySpecifier = ('cpuUsage' | 'logs' | 'memoryUsageMB' | 'organization' | 'startedAt' | 'status' | 'subscription' | AppDeploymentWorkloadKeySpecifier)[];
export type AppDeploymentWorkloadFieldPolicy = {
	cpuUsage?: FieldPolicy<any> | FieldReadFunction<any>,
	logs?: FieldPolicy<any> | FieldReadFunction<any>,
	memoryUsageMB?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppHasActiveSubscriptionsKeySpecifier = ('activeStandingOffersCount' | 'activeSubscriptionOffersCount' | 'activeSubscriptionsCount' | 'appSlug' | AppHasActiveSubscriptionsKeySpecifier)[];
export type AppHasActiveSubscriptionsFieldPolicy = {
	activeStandingOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	activeSubscriptionOffersCount?: FieldPolicy<any> | FieldReadFunction<any>,
	activeSubscriptionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	appSlug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSessionKeySpecifier = ('accessType' | 'app' | 'endTime' | 'id' | 'ownerOrganization' | 'startTime' | 'userEmail' | 'userId' | AppSessionKeySpecifier)[];
export type AppSessionFieldPolicy = {
	accessType?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ownerOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSessionConnectionKeySpecifier = ('edges' | 'pageInfo' | AppSessionConnectionKeySpecifier)[];
export type AppSessionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSessionEdgeKeySpecifier = ('cursor' | 'node' | AppSessionEdgeKeySpecifier)[];
export type AppSessionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSessionStartedKeySpecifier = ('sessionId' | AppSessionStartedKeySpecifier)[];
export type AppSessionStartedFieldPolicy = {
	sessionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSubscriptionKeySpecifier = ('apiKeys' | 'app' | 'createdAt' | 'expiresAt' | 'id' | 'inboundOrganization' | 'monthlyPriceUSD' | 'name' | 'outboundOrganization' | 'status' | AppSubscriptionKeySpecifier)[];
export type AppSubscriptionFieldPolicy = {
	apiKeys?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inboundOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyPriceUSD?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	outboundOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSubscriptionInvalidStatusKeySpecifier = ('id' | AppSubscriptionInvalidStatusKeySpecifier)[];
export type AppSubscriptionInvalidStatusFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppSubscriptionNotFoundKeySpecifier = ('id' | AppSubscriptionNotFoundKeySpecifier)[];
export type AppSubscriptionNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppVersionKeySpecifier = ('id' | 'message' | 'releaseNotes' | 'tasks' | 'userGuide' | 'version' | AppVersionKeySpecifier)[];
export type AppVersionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseNotes?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	userGuide?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppVersionDocumentationFileKeySpecifier = ('contentBase64' | 'filename' | AppVersionDocumentationFileKeySpecifier)[];
export type AppVersionDocumentationFileFieldPolicy = {
	contentBase64?: FieldPolicy<any> | FieldReadFunction<any>,
	filename?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppVersionDownloadURLKeySpecifier = ('url' | AppVersionDownloadURLKeySpecifier)[];
export type AppVersionDownloadURLFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppVersionUploadURLKeySpecifier = ('url' | AppVersionUploadURLKeySpecifier)[];
export type AppVersionUploadURLFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type Auth0WhiteLabelInvitationKeySpecifier = ('email' | 'invitedAt' | Auth0WhiteLabelInvitationKeySpecifier)[];
export type Auth0WhiteLabelInvitationFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	invitedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildEventFailureKeySpecifier = ('result' | BuildEventFailureKeySpecifier)[];
export type BuildEventFailureFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildEventInfoKeySpecifier = ('result' | BuildEventInfoKeySpecifier)[];
export type BuildEventInfoFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildEventSuccessKeySpecifier = ('result' | BuildEventSuccessKeySpecifier)[];
export type BuildEventSuccessFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionKeySpecifier = ('collections' | 'document' | 'documents' | 'files' | 'id' | 'key' | 'tags' | CollectionKeySpecifier)[];
export type CollectionFieldPolicy = {
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	files?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionConnectionKeySpecifier = ('edges' | 'pageInfo' | CollectionConnectionKeySpecifier)[];
export type CollectionConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDocumentKeySpecifier = ('data' | 'id' | 'key' | 'tags' | CollectionDocumentKeySpecifier)[];
export type CollectionDocumentFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDocumentConnectionKeySpecifier = ('edges' | 'pageInfo' | CollectionDocumentConnectionKeySpecifier)[];
export type CollectionDocumentConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDocumentEdgeKeySpecifier = ('cursor' | 'node' | CollectionDocumentEdgeKeySpecifier)[];
export type CollectionDocumentEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDocumentNotFoundKeySpecifier = ('id' | CollectionDocumentNotFoundKeySpecifier)[];
export type CollectionDocumentNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionEdgeKeySpecifier = ('cursor' | 'node' | CollectionEdgeKeySpecifier)[];
export type CollectionEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionFileKeySpecifier = ('downloadURL' | 'id' | 'key' | 'tags' | 'uploadURL' | CollectionFileKeySpecifier)[];
export type CollectionFileFieldPolicy = {
	downloadURL?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionFileConnectionKeySpecifier = ('edges' | 'pageInfo' | CollectionFileConnectionKeySpecifier)[];
export type CollectionFileConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionFileEdgeKeySpecifier = ('cursor' | 'node' | CollectionFileEdgeKeySpecifier)[];
export type CollectionFileEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionFileNotFoundKeySpecifier = ('id' | CollectionFileNotFoundKeySpecifier)[];
export type CollectionFileNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionNotFoundKeySpecifier = ('id' | CollectionNotFoundKeySpecifier)[];
export type CollectionNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionOrganizationMismatchKeySpecifier = ('parentID' | 'parentOrganizationID' | 'requestedOrganizationID' | CollectionOrganizationMismatchKeySpecifier)[];
export type CollectionOrganizationMismatchFieldPolicy = {
	parentID?: FieldPolicy<any> | FieldReadFunction<any>,
	parentOrganizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	requestedOrganizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerAccountPortalURLKeySpecifier = ('url' | CustomerAccountPortalURLKeySpecifier)[];
export type CustomerAccountPortalURLFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmailNotificationPreferencesKeySpecifier = ('DeploymentUpdatesDisabled' | 'MarketingDisabled' | 'OnboardingDisabled' | 'OrganizationUpdatesDisabled' | 'ReleaseNotesDisabled' | EmailNotificationPreferencesKeySpecifier)[];
export type EmailNotificationPreferencesFieldPolicy = {
	DeploymentUpdatesDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	MarketingDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	OnboardingDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	OrganizationUpdatesDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	ReleaseNotesDisabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseKeySpecifier = ('hasCustomerAccount' | 'id' | 'members' | 'name' | 'organizations' | 'paymentAccount' | 'plan' | 'slug' | EnterpriseKeySpecifier)[];
export type EnterpriseFieldPolicy = {
	hasCustomerAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	plan?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseInvalidMaxOrganizationsKeySpecifier = ('maxOrganizations' | 'reason' | EnterpriseInvalidMaxOrganizationsKeySpecifier)[];
export type EnterpriseInvalidMaxOrganizationsFieldPolicy = {
	maxOrganizations?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseInvalidUnitsCountKeySpecifier = ('reason' | 'unitsCount' | EnterpriseInvalidUnitsCountKeySpecifier)[];
export type EnterpriseInvalidUnitsCountFieldPolicy = {
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseNotFoundKeySpecifier = ('id' | EnterpriseNotFoundKeySpecifier)[];
export type EnterpriseNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterprisePlanKeySpecifier = ('maxOrganizations' | 'unitsCount' | EnterprisePlanKeySpecifier)[];
export type EnterprisePlanFieldPolicy = {
	maxOrganizations?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnterpriseSlugInvalidKeySpecifier = ('slug' | EnterpriseSlugInvalidKeySpecifier)[];
export type EnterpriseSlugInvalidFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FeedbackResultKeySpecifier = ('email' | FeedbackResultKeySpecifier)[];
export type FeedbackResultFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GitHubRepositoryNotFoundKeySpecifier = ('owner' | 'repo' | GitHubRepositoryNotFoundKeySpecifier)[];
export type GitHubRepositoryNotFoundFieldPolicy = {
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	repo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GithubRepositoryReleaseKeySpecifier = ('body' | 'id' | 'name' | 'publishedAt' | GithubRepositoryReleaseKeySpecifier)[];
export type GithubRepositoryReleaseFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvalidEmailKeySpecifier = ('email' | InvalidEmailKeySpecifier)[];
export type InvalidEmailFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobKeySpecifier = ('createdAt' | 'id' | 'proxyUrl' | 'status' | 'user' | JobKeySpecifier)[];
export type JobFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	proxyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobHeartbeatFailureKeySpecifier = ('result' | JobHeartbeatFailureKeySpecifier)[];
export type JobHeartbeatFailureFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobHeartbeatSuccessKeySpecifier = ('id' | JobHeartbeatSuccessKeySpecifier)[];
export type JobHeartbeatSuccessFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobNotFoundKeySpecifier = ('id' | JobNotFoundKeySpecifier)[];
export type JobNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LogMessageKeySpecifier = ('message' | 'time' | LogMessageKeySpecifier)[];
export type LogMessageFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('Auth0WhiteLabelInvitationCreate' | 'appAPIKeyRename' | 'appAPIKeyRevoke' | 'appCreate' | 'appDelete' | 'appDeploy' | 'appDeployHeartbeat' | 'appDeployShare' | 'appDeployUnshare' | 'appDeploymentAPIKeyCreate' | 'appDescriptionUpdate' | 'appRename' | 'appSharedDeployHeartbeat' | 'appSubscriptionAPIKeyCreate' | 'appVersionCreate' | 'appVersionCreateGitHub' | 'appVersionDownloadURL' | 'appVersionUploadURL' | 'buildPush' | 'collectionCreate' | 'collectionDocumentDelete' | 'collectionDocumentSet' | 'collectionDocumentTagAdd' | 'collectionDocumentTagDelete' | 'collectionFileCreate' | 'collectionFileDelete' | 'collectionFileTagAdd' | 'collectionFileTagDelete' | 'collectionTagAdd' | 'collectionTagDelete' | 'customerAccountCreatePortalURL' | 'enterpriseCreate' | 'enterpriseMemberAdd' | 'enterpriseMemberRemove' | 'enterprisePlanChange' | 'jobHeartbeat' | 'jobStart' | 'jobStop' | 'meDelete' | 'organizationCreate' | 'organizationDelete' | 'organizationInvitationAccept' | 'organizationInvitationCreate' | 'organizationInvitationDelete' | 'organizationInvitationReject' | 'organizationLinkToEnterprise' | 'organizationMemberEditRole' | 'organizationMemberRemove' | 'organizationRename' | 'organizationTierChange' | 'paymentAccountCreate' | 'paymentAccountDelete' | 'paymentAccountOnboardURLCreate' | 'paymentAccountUpdateURLCreate' | 'personalAccessTokenCreate' | 'personalAccessTokenRevoke' | 'resendEmailVerification' | 'sendFeedback' | 'sendPlatformMail' | 'sendRequestWhiteLabelAccessMail' | 'standingOfferAccept' | 'standingOfferCancel' | 'standingOfferCreate' | 'subscriptionCancelInbound' | 'subscriptionCancelOutbound' | 'subscriptionDeployHeartbeat' | 'subscriptionOfferAccept' | 'subscriptionOfferCreate' | 'subscriptionOfferReject' | 'subscriptionOfferWithdraw' | 'taskInstanceSetOutput' | 'taskInstanceUpdateProgress' | 'taskStart' | 'taskStop' | 'toolCreate' | 'toolDelete' | 'toolPublish' | 'toolUnpublish' | 'userEmailNotificationPreferenceUpdate' | 'userOnboardingDisable' | 'userOnboardingEnable' | 'userRename' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	Auth0WhiteLabelInvitationCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appAPIKeyRename?: FieldPolicy<any> | FieldReadFunction<any>,
	appAPIKeyRevoke?: FieldPolicy<any> | FieldReadFunction<any>,
	appCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeploy?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeployHeartbeat?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeployShare?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeployUnshare?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeploymentAPIKeyCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appDescriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	appRename?: FieldPolicy<any> | FieldReadFunction<any>,
	appSharedDeployHeartbeat?: FieldPolicy<any> | FieldReadFunction<any>,
	appSubscriptionAPIKeyCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersionCreateGitHub?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersionDownloadURL?: FieldPolicy<any> | FieldReadFunction<any>,
	appVersionUploadURL?: FieldPolicy<any> | FieldReadFunction<any>,
	buildPush?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDocumentDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDocumentSet?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDocumentTagAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDocumentTagDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionFileCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionFileDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionFileTagAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionFileTagDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionTagAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionTagDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	customerAccountCreatePortalURL?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseMemberAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	enterpriseMemberRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	enterprisePlanChange?: FieldPolicy<any> | FieldReadFunction<any>,
	jobHeartbeat?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStart?: FieldPolicy<any> | FieldReadFunction<any>,
	jobStop?: FieldPolicy<any> | FieldReadFunction<any>,
	meDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationInvitationAccept?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationInvitationCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationInvitationDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationInvitationReject?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationLinkToEnterprise?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationMemberEditRole?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationMemberRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationRename?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationTierChange?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccountCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccountDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccountOnboardURLCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccountUpdateURLCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	personalAccessTokenCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	personalAccessTokenRevoke?: FieldPolicy<any> | FieldReadFunction<any>,
	resendEmailVerification?: FieldPolicy<any> | FieldReadFunction<any>,
	sendFeedback?: FieldPolicy<any> | FieldReadFunction<any>,
	sendPlatformMail?: FieldPolicy<any> | FieldReadFunction<any>,
	sendRequestWhiteLabelAccessMail?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOfferAccept?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOfferCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOfferCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionCancelInbound?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionCancelOutbound?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionDeployHeartbeat?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionOfferAccept?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionOfferCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionOfferReject?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionOfferWithdraw?: FieldPolicy<any> | FieldReadFunction<any>,
	taskInstanceSetOutput?: FieldPolicy<any> | FieldReadFunction<any>,
	taskInstanceUpdateProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	taskStart?: FieldPolicy<any> | FieldReadFunction<any>,
	taskStop?: FieldPolicy<any> | FieldReadFunction<any>,
	toolCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	toolDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	toolPublish?: FieldPolicy<any> | FieldReadFunction<any>,
	toolUnpublish?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmailNotificationPreferenceUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	userOnboardingDisable?: FieldPolicy<any> | FieldReadFunction<any>,
	userOnboardingEnable?: FieldPolicy<any> | FieldReadFunction<any>,
	userRename?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferInvalidExpiresAtKeySpecifier = ('expiresAt' | OfferInvalidExpiresAtKeySpecifier)[];
export type OfferInvalidExpiresAtFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferInvalidMonthlyPriceUSDKeySpecifier = ('monthlyPriceUSD' | OfferInvalidMonthlyPriceUSDKeySpecifier)[];
export type OfferInvalidMonthlyPriceUSDFieldPolicy = {
	monthlyPriceUSD?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfferInvalidTrialDaysKeySpecifier = ('maxTrialDays' | 'trialDays' | OfferInvalidTrialDaysKeySpecifier)[];
export type OfferInvalidTrialDaysFieldPolicy = {
	maxTrialDays?: FieldPolicy<any> | FieldReadFunction<any>,
	trialDays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationKeySpecifier = ('appSessions' | 'apps' | 'createdAt' | 'enterprise' | 'hasCustomerAccount' | 'id' | 'members' | 'name' | 'outboundSubscriptionOffers' | 'outboundSubscriptions' | 'paymentAccount' | 'pendingInvitations' | 'slug' | 'standingOffers' | 'tier' | 'tierExpiresAt' | OrganizationKeySpecifier)[];
export type OrganizationFieldPolicy = {
	appSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	apps?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	enterprise?: FieldPolicy<any> | FieldReadFunction<any>,
	hasCustomerAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	outboundSubscriptionOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	outboundSubscriptions?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingInvitations?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOffers?: FieldPolicy<any> | FieldReadFunction<any>,
	tier?: FieldPolicy<any> | FieldReadFunction<any>,
	tierExpiresAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationDeletedKeySpecifier = ('id' | OrganizationDeletedKeySpecifier)[];
export type OrganizationDeletedFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationHasAppsKeySpecifier = ('id' | OrganizationHasAppsKeySpecifier)[];
export type OrganizationHasAppsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationHasInboundSubscriptionsKeySpecifier = ('id' | OrganizationHasInboundSubscriptionsKeySpecifier)[];
export type OrganizationHasInboundSubscriptionsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationHasNoPaymentAccountKeySpecifier = ('organizationID' | OrganizationHasNoPaymentAccountKeySpecifier)[];
export type OrganizationHasNoPaymentAccountFieldPolicy = {
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationInvitationKeySpecifier = ('email' | 'id' | 'invitedAt' | 'organizationName' | 'role' | OrganizationInvitationKeySpecifier)[];
export type OrganizationInvitationFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invitedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationInvitationDeletedKeySpecifier = ('id' | OrganizationInvitationDeletedKeySpecifier)[];
export type OrganizationInvitationDeletedFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationInvitationExistsKeySpecifier = ('email' | OrganizationInvitationExistsKeySpecifier)[];
export type OrganizationInvitationExistsFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationInvitationNotFoundKeySpecifier = ('id' | OrganizationInvitationNotFoundKeySpecifier)[];
export type OrganizationInvitationNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationInvitationRejectedKeySpecifier = ('id' | OrganizationInvitationRejectedKeySpecifier)[];
export type OrganizationInvitationRejectedFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationMembershipKeySpecifier = ('id' | 'organization' | 'role' | 'user' | OrganizationMembershipKeySpecifier)[];
export type OrganizationMembershipFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationMissingPaymentMethodKeySpecifier = ('organizationID' | OrganizationMissingPaymentMethodKeySpecifier)[];
export type OrganizationMissingPaymentMethodFieldPolicy = {
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationNotFoundKeySpecifier = ('id' | 'slug' | OrganizationNotFoundKeySpecifier)[];
export type OrganizationNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationRenameFailureKeySpecifier = ('result' | OrganizationRenameFailureKeySpecifier)[];
export type OrganizationRenameFailureFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationSlugInvalidKeySpecifier = ('slug' | OrganizationSlugInvalidKeySpecifier)[];
export type OrganizationSlugInvalidFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationSlugOccupiedKeySpecifier = ('slug' | OrganizationSlugOccupiedKeySpecifier)[];
export type OrganizationSlugOccupiedFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationTierKeySpecifier = ('id' | 'name' | 'unitsCount' | OrganizationTierKeySpecifier)[];
export type OrganizationTierFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	unitsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountKeySpecifier = ('id' | 'status' | PaymentAccountKeySpecifier)[];
export type PaymentAccountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountDeletedKeySpecifier = ('organizationID' | PaymentAccountDeletedKeySpecifier)[];
export type PaymentAccountDeletedFieldPolicy = {
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountExistsKeySpecifier = ('organizationSlug' | 'paymentAccount' | PaymentAccountExistsKeySpecifier)[];
export type PaymentAccountExistsFieldPolicy = {
	organizationSlug?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentAccount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountHasActiveSubscriptionsKeySpecifier = ('activeSubscriptionsCount' | 'organizationID' | PaymentAccountHasActiveSubscriptionsKeySpecifier)[];
export type PaymentAccountHasActiveSubscriptionsFieldPolicy = {
	activeSubscriptionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountNotFoundKeySpecifier = ('organizationID' | PaymentAccountNotFoundKeySpecifier)[];
export type PaymentAccountNotFoundFieldPolicy = {
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAccountURLKeySpecifier = ('url' | PaymentAccountURLKeySpecifier)[];
export type PaymentAccountURLFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentConfigurationKeySpecifier = ('monthlyPriceUSD' | 'trialDays' | PaymentConfigurationKeySpecifier)[];
export type PaymentConfigurationFieldPolicy = {
	monthlyPriceUSD?: FieldPolicy<any> | FieldReadFunction<any>,
	trialDays?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonalAccessTokenAlreadyExistsKeySpecifier = ('name' | PersonalAccessTokenAlreadyExistsKeySpecifier)[];
export type PersonalAccessTokenAlreadyExistsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonalAccessTokenCreatedKeySpecifier = ('entry' | 'token' | PersonalAccessTokenCreatedKeySpecifier)[];
export type PersonalAccessTokenCreatedFieldPolicy = {
	entry?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonalAccessTokenEntryKeySpecifier = ('description' | 'expiresAt' | 'id' | 'name' | PersonalAccessTokenEntryKeySpecifier)[];
export type PersonalAccessTokenEntryFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonalAccessTokenInvalidNameKeySpecifier = ('name' | 'reason' | PersonalAccessTokenInvalidNameKeySpecifier)[];
export type PersonalAccessTokenInvalidNameFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlatformMailKeySpecifier = ('emailCategory' | 'sendGridTemplateID' | 'testMail' | 'to' | 'userType' | PlatformMailKeySpecifier)[];
export type PlatformMailFieldPolicy = {
	emailCategory?: FieldPolicy<any> | FieldReadFunction<any>,
	sendGridTemplateID?: FieldPolicy<any> | FieldReadFunction<any>,
	testMail?: FieldPolicy<any> | FieldReadFunction<any>,
	to?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PublicToolKeySpecifier = ('createdAt' | 'description' | 'developer' | 'id' | 'name' | 'pictureUrl' | 'publicUrl' | PublicToolKeySpecifier)[];
export type PublicToolFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	developer?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pictureUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('app' | 'appSessions' | 'appWorkloads' | 'checkVersion' | 'collection' | 'collectionDocument' | 'collectionFile' | 'job' | 'jobsByTool' | 'me' | 'numerousReleases' | 'organization' | 'organizationById' | 'organizationInvitation' | 'publicTools' | 'standingOffer' | 'subscription' | 'subscriptionOffer' | 'taskInstance' | 'taskInstances' | 'tasks' | 'tool' | 'tools' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appSessions?: FieldPolicy<any> | FieldReadFunction<any>,
	appWorkloads?: FieldPolicy<any> | FieldReadFunction<any>,
	checkVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionFile?: FieldPolicy<any> | FieldReadFunction<any>,
	job?: FieldPolicy<any> | FieldReadFunction<any>,
	jobsByTool?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	numerousReleases?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationById?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	publicTools?: FieldPolicy<any> | FieldReadFunction<any>,
	standingOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	taskInstance?: FieldPolicy<any> | FieldReadFunction<any>,
	taskInstances?: FieldPolicy<any> | FieldReadFunction<any>,
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	tool?: FieldPolicy<any> | FieldReadFunction<any>,
	tools?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestWhiteLabelAccessMailKeySpecifier = ('email' | 'message' | RequestWhiteLabelAccessMailKeySpecifier)[];
export type RequestWhiteLabelAccessMailFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResendEmailVerificationSuccessKeySpecifier = ('userId' | ResendEmailVerificationSuccessKeySpecifier)[];
export type ResendEmailVerificationSuccessFieldPolicy = {
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandingOfferKeySpecifier = ('app' | 'createdAt' | 'id' | 'message' | 'name' | 'offeringOrganization' | 'payment' | 'status' | StandingOfferKeySpecifier)[];
export type StandingOfferFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offeringOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StopJobPayloadKeySpecifier = ('message' | StopJobPayloadKeySpecifier)[];
export type StopJobPayloadFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('appDeployEvents' | 'appDeployLogs' | 'appSession' | 'buildEvents' | 'deployEvents' | 'logs' | 'sharedAppSession' | 'subscriptionAppSession' | 'taskInstanceLogs' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	appDeployEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeployLogs?: FieldPolicy<any> | FieldReadFunction<any>,
	appSession?: FieldPolicy<any> | FieldReadFunction<any>,
	buildEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	deployEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	logs?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionAppSession?: FieldPolicy<any> | FieldReadFunction<any>,
	taskInstanceLogs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionAlreadyExistsKeySpecifier = ('id' | SubscriptionAlreadyExistsKeySpecifier)[];
export type SubscriptionAlreadyExistsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionOfferKeySpecifier = ('app' | 'createdAt' | 'email' | 'expiresAt' | 'id' | 'message' | 'name' | 'offeringOrganization' | 'payment' | 'status' | SubscriptionOfferKeySpecifier)[];
export type SubscriptionOfferFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	offeringOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionOfferCheckoutSessionKeySpecifier = ('portalURL' | SubscriptionOfferCheckoutSessionKeySpecifier)[];
export type SubscriptionOfferCheckoutSessionFieldPolicy = {
	portalURL?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionOfferInvalidStatusKeySpecifier = ('id' | SubscriptionOfferInvalidStatusKeySpecifier)[];
export type SubscriptionOfferInvalidStatusFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionOfferNotFoundKeySpecifier = ('id' | SubscriptionOfferNotFoundKeySpecifier)[];
export type SubscriptionOfferNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TagKeySpecifier = ('key' | 'value' | TagKeySpecifier)[];
export type TagFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskKeySpecifier = ('appVersion' | 'command' | 'id' | TaskKeySpecifier)[];
export type TaskFieldPolicy = {
	appVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	command?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskInstanceKeySpecifier = ('createdAt' | 'id' | 'input' | 'output' | 'progress' | 'task' | 'workload' | TaskInstanceKeySpecifier)[];
export type TaskInstanceFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	input?: FieldPolicy<any> | FieldReadFunction<any>,
	output?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	task?: FieldPolicy<any> | FieldReadFunction<any>,
	workload?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskInstanceProgressKeySpecifier = ('message' | 'value' | TaskInstanceProgressKeySpecifier)[];
export type TaskInstanceProgressFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskInstanceWorkloadKeySpecifier = ('cpuUsage' | 'exitCode' | 'logs' | 'memoryUsageMB' | 'startedAt' | 'status' | TaskInstanceWorkloadKeySpecifier)[];
export type TaskInstanceWorkloadFieldPolicy = {
	cpuUsage?: FieldPolicy<any> | FieldReadFunction<any>,
	exitCode?: FieldPolicy<any> | FieldReadFunction<any>,
	logs?: FieldPolicy<any> | FieldReadFunction<any>,
	memoryUsageMB?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaskStopResultKeySpecifier = ('taskInstanceID' | TaskStopResultKeySpecifier)[];
export type TaskStopResultFieldPolicy = {
	taskInstanceID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ToolKeySpecifier = ('createdAt' | 'description' | 'id' | 'name' | 'privateUrl' | 'publicUrl' | 'sharedUrl' | 'user' | ToolKeySpecifier)[];
export type ToolFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	publicUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	sharedUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ToolDeleteFailureKeySpecifier = ('result' | ToolDeleteFailureKeySpecifier)[];
export type ToolDeleteFailureFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ToolDeleteSuccessKeySpecifier = ('result' | ToolDeleteSuccessKeySpecifier)[];
export type ToolDeleteSuccessFieldPolicy = {
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('email' | 'enterprises' | 'fullName' | 'id' | 'memberships' | 'onboardingStepsCompleted' | 'pendingInvitations' | 'personalAccessTokens' | 'preferences' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enterprises?: FieldPolicy<any> | FieldReadFunction<any>,
	fullName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	memberships?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingStepsCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingInvitations?: FieldPolicy<any> | FieldReadFunction<any>,
	personalAccessTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	preferences?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDeletedKeySpecifier = ('id' | UserDeletedKeySpecifier)[];
export type UserDeletedFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserHasSoleAdminshipKeySpecifier = ('id' | UserHasSoleAdminshipKeySpecifier)[];
export type UserHasSoleAdminshipFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNotFoundKeySpecifier = ('id' | UserNotFoundKeySpecifier)[];
export type UserNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserOnboardingStepsCompletedKeySpecifier = ('CreatedApp' | 'CreatedSubscriptionOffer' | 'InvitedUser' | 'UploadedCode' | UserOnboardingStepsCompletedKeySpecifier)[];
export type UserOnboardingStepsCompletedFieldPolicy = {
	CreatedApp?: FieldPolicy<any> | FieldReadFunction<any>,
	CreatedSubscriptionOffer?: FieldPolicy<any> | FieldReadFunction<any>,
	InvitedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	UploadedCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPreferencesKeySpecifier = ('emailNotifications' | 'onboardingDisabled' | UserPreferencesKeySpecifier)[];
export type UserPreferencesFieldPolicy = {
	emailNotifications?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingDisabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VersionCheckCriticalKeySpecifier = ('message' | VersionCheckCriticalKeySpecifier)[];
export type VersionCheckCriticalFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VersionCheckOKKeySpecifier = ('version' | VersionCheckOKKeySpecifier)[];
export type VersionCheckOKFieldPolicy = {
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VersionCheckWarningKeySpecifier = ('message' | VersionCheckWarningKeySpecifier)[];
export type VersionCheckWarningFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VersionUnknownKeySpecifier = ('version' | VersionUnknownKeySpecifier)[];
export type VersionUnknownFieldPolicy = {
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WhiteLabelConfigNotFoundKeySpecifier = ('id' | WhiteLabelConfigNotFoundKeySpecifier)[];
export type WhiteLabelConfigNotFoundFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkloadLogEntryKeySpecifier = ('text' | 'timestamp' | WorkloadLogEntryKeySpecifier)[];
export type WorkloadLogEntryFieldPolicy = {
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkloadLogEntryConnectionKeySpecifier = ('edges' | 'pageInfo' | WorkloadLogEntryConnectionKeySpecifier)[];
export type WorkloadLogEntryConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkloadResourceUsageKeySpecifier = ('current' | 'timeseries' | WorkloadResourceUsageKeySpecifier)[];
export type WorkloadResourceUsageFieldPolicy = {
	current?: FieldPolicy<any> | FieldReadFunction<any>,
	timeseries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WorkloadResourceUsageDataPointKeySpecifier = ('timestamp' | 'value' | WorkloadResourceUsageDataPointKeySpecifier)[];
export type WorkloadResourceUsageDataPointFieldPolicy = {
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type buildConfigurationKeySpecifier = ('buildId' | buildConfigurationKeySpecifier)[];
export type buildConfigurationFieldPolicy = {
	buildId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	App?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppKeySpecifier | (() => undefined | AppKeySpecifier),
		fields?: AppFieldPolicy,
	},
	AppAPIKey?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppAPIKeyKeySpecifier | (() => undefined | AppAPIKeyKeySpecifier),
		fields?: AppAPIKeyFieldPolicy,
	},
	AppAPIKeyAlreadyExists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppAPIKeyAlreadyExistsKeySpecifier | (() => undefined | AppAPIKeyAlreadyExistsKeySpecifier),
		fields?: AppAPIKeyAlreadyExistsFieldPolicy,
	},
	AppAPIKeyInvalidName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppAPIKeyInvalidNameKeySpecifier | (() => undefined | AppAPIKeyInvalidNameKeySpecifier),
		fields?: AppAPIKeyInvalidNameFieldPolicy,
	},
	AppBuildErrorEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppBuildErrorEventKeySpecifier | (() => undefined | AppBuildErrorEventKeySpecifier),
		fields?: AppBuildErrorEventFieldPolicy,
	},
	AppBuildMessageEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppBuildMessageEventKeySpecifier | (() => undefined | AppBuildMessageEventKeySpecifier),
		fields?: AppBuildMessageEventFieldPolicy,
	},
	AppDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeletedKeySpecifier | (() => undefined | AppDeletedKeySpecifier),
		fields?: AppDeletedFieldPolicy,
	},
	AppDeployLogEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeployLogEntryKeySpecifier | (() => undefined | AppDeployLogEntryKeySpecifier),
		fields?: AppDeployLogEntryFieldPolicy,
	},
	AppDeployLogEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeployLogEntryConnectionKeySpecifier | (() => undefined | AppDeployLogEntryConnectionKeySpecifier),
		fields?: AppDeployLogEntryConnectionFieldPolicy,
	},
	AppDeployment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentKeySpecifier | (() => undefined | AppDeploymentKeySpecifier),
		fields?: AppDeploymentFieldPolicy,
	},
	AppDeploymentHeartbeat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentHeartbeatKeySpecifier | (() => undefined | AppDeploymentHeartbeatKeySpecifier),
		fields?: AppDeploymentHeartbeatFieldPolicy,
	},
	AppDeploymentResourceUsage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentResourceUsageKeySpecifier | (() => undefined | AppDeploymentResourceUsageKeySpecifier),
		fields?: AppDeploymentResourceUsageFieldPolicy,
	},
	AppDeploymentResourceUsageDataPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentResourceUsageDataPointKeySpecifier | (() => undefined | AppDeploymentResourceUsageDataPointKeySpecifier),
		fields?: AppDeploymentResourceUsageDataPointFieldPolicy,
	},
	AppDeploymentStatusEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentStatusEventKeySpecifier | (() => undefined | AppDeploymentStatusEventKeySpecifier),
		fields?: AppDeploymentStatusEventFieldPolicy,
	},
	AppDeploymentVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentVersionKeySpecifier | (() => undefined | AppDeploymentVersionKeySpecifier),
		fields?: AppDeploymentVersionFieldPolicy,
	},
	AppDeploymentWorkload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeploymentWorkloadKeySpecifier | (() => undefined | AppDeploymentWorkloadKeySpecifier),
		fields?: AppDeploymentWorkloadFieldPolicy,
	},
	AppHasActiveSubscriptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppHasActiveSubscriptionsKeySpecifier | (() => undefined | AppHasActiveSubscriptionsKeySpecifier),
		fields?: AppHasActiveSubscriptionsFieldPolicy,
	},
	AppSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSessionKeySpecifier | (() => undefined | AppSessionKeySpecifier),
		fields?: AppSessionFieldPolicy,
	},
	AppSessionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSessionConnectionKeySpecifier | (() => undefined | AppSessionConnectionKeySpecifier),
		fields?: AppSessionConnectionFieldPolicy,
	},
	AppSessionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSessionEdgeKeySpecifier | (() => undefined | AppSessionEdgeKeySpecifier),
		fields?: AppSessionEdgeFieldPolicy,
	},
	AppSessionStarted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSessionStartedKeySpecifier | (() => undefined | AppSessionStartedKeySpecifier),
		fields?: AppSessionStartedFieldPolicy,
	},
	AppSubscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSubscriptionKeySpecifier | (() => undefined | AppSubscriptionKeySpecifier),
		fields?: AppSubscriptionFieldPolicy,
	},
	AppSubscriptionInvalidStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSubscriptionInvalidStatusKeySpecifier | (() => undefined | AppSubscriptionInvalidStatusKeySpecifier),
		fields?: AppSubscriptionInvalidStatusFieldPolicy,
	},
	AppSubscriptionNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppSubscriptionNotFoundKeySpecifier | (() => undefined | AppSubscriptionNotFoundKeySpecifier),
		fields?: AppSubscriptionNotFoundFieldPolicy,
	},
	AppVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppVersionKeySpecifier | (() => undefined | AppVersionKeySpecifier),
		fields?: AppVersionFieldPolicy,
	},
	AppVersionDocumentationFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppVersionDocumentationFileKeySpecifier | (() => undefined | AppVersionDocumentationFileKeySpecifier),
		fields?: AppVersionDocumentationFileFieldPolicy,
	},
	AppVersionDownloadURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppVersionDownloadURLKeySpecifier | (() => undefined | AppVersionDownloadURLKeySpecifier),
		fields?: AppVersionDownloadURLFieldPolicy,
	},
	AppVersionUploadURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppVersionUploadURLKeySpecifier | (() => undefined | AppVersionUploadURLKeySpecifier),
		fields?: AppVersionUploadURLFieldPolicy,
	},
	Auth0WhiteLabelInvitation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | Auth0WhiteLabelInvitationKeySpecifier | (() => undefined | Auth0WhiteLabelInvitationKeySpecifier),
		fields?: Auth0WhiteLabelInvitationFieldPolicy,
	},
	BuildEventFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildEventFailureKeySpecifier | (() => undefined | BuildEventFailureKeySpecifier),
		fields?: BuildEventFailureFieldPolicy,
	},
	BuildEventInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildEventInfoKeySpecifier | (() => undefined | BuildEventInfoKeySpecifier),
		fields?: BuildEventInfoFieldPolicy,
	},
	BuildEventSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildEventSuccessKeySpecifier | (() => undefined | BuildEventSuccessKeySpecifier),
		fields?: BuildEventSuccessFieldPolicy,
	},
	Collection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionKeySpecifier | (() => undefined | CollectionKeySpecifier),
		fields?: CollectionFieldPolicy,
	},
	CollectionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionConnectionKeySpecifier | (() => undefined | CollectionConnectionKeySpecifier),
		fields?: CollectionConnectionFieldPolicy,
	},
	CollectionDocument?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDocumentKeySpecifier | (() => undefined | CollectionDocumentKeySpecifier),
		fields?: CollectionDocumentFieldPolicy,
	},
	CollectionDocumentConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDocumentConnectionKeySpecifier | (() => undefined | CollectionDocumentConnectionKeySpecifier),
		fields?: CollectionDocumentConnectionFieldPolicy,
	},
	CollectionDocumentEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDocumentEdgeKeySpecifier | (() => undefined | CollectionDocumentEdgeKeySpecifier),
		fields?: CollectionDocumentEdgeFieldPolicy,
	},
	CollectionDocumentNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDocumentNotFoundKeySpecifier | (() => undefined | CollectionDocumentNotFoundKeySpecifier),
		fields?: CollectionDocumentNotFoundFieldPolicy,
	},
	CollectionEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionEdgeKeySpecifier | (() => undefined | CollectionEdgeKeySpecifier),
		fields?: CollectionEdgeFieldPolicy,
	},
	CollectionFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionFileKeySpecifier | (() => undefined | CollectionFileKeySpecifier),
		fields?: CollectionFileFieldPolicy,
	},
	CollectionFileConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionFileConnectionKeySpecifier | (() => undefined | CollectionFileConnectionKeySpecifier),
		fields?: CollectionFileConnectionFieldPolicy,
	},
	CollectionFileEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionFileEdgeKeySpecifier | (() => undefined | CollectionFileEdgeKeySpecifier),
		fields?: CollectionFileEdgeFieldPolicy,
	},
	CollectionFileNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionFileNotFoundKeySpecifier | (() => undefined | CollectionFileNotFoundKeySpecifier),
		fields?: CollectionFileNotFoundFieldPolicy,
	},
	CollectionNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionNotFoundKeySpecifier | (() => undefined | CollectionNotFoundKeySpecifier),
		fields?: CollectionNotFoundFieldPolicy,
	},
	CollectionOrganizationMismatch?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionOrganizationMismatchKeySpecifier | (() => undefined | CollectionOrganizationMismatchKeySpecifier),
		fields?: CollectionOrganizationMismatchFieldPolicy,
	},
	CustomerAccountPortalURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerAccountPortalURLKeySpecifier | (() => undefined | CustomerAccountPortalURLKeySpecifier),
		fields?: CustomerAccountPortalURLFieldPolicy,
	},
	EmailNotificationPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmailNotificationPreferencesKeySpecifier | (() => undefined | EmailNotificationPreferencesKeySpecifier),
		fields?: EmailNotificationPreferencesFieldPolicy,
	},
	Enterprise?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseKeySpecifier | (() => undefined | EnterpriseKeySpecifier),
		fields?: EnterpriseFieldPolicy,
	},
	EnterpriseInvalidMaxOrganizations?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseInvalidMaxOrganizationsKeySpecifier | (() => undefined | EnterpriseInvalidMaxOrganizationsKeySpecifier),
		fields?: EnterpriseInvalidMaxOrganizationsFieldPolicy,
	},
	EnterpriseInvalidUnitsCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseInvalidUnitsCountKeySpecifier | (() => undefined | EnterpriseInvalidUnitsCountKeySpecifier),
		fields?: EnterpriseInvalidUnitsCountFieldPolicy,
	},
	EnterpriseNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseNotFoundKeySpecifier | (() => undefined | EnterpriseNotFoundKeySpecifier),
		fields?: EnterpriseNotFoundFieldPolicy,
	},
	EnterprisePlan?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterprisePlanKeySpecifier | (() => undefined | EnterprisePlanKeySpecifier),
		fields?: EnterprisePlanFieldPolicy,
	},
	EnterpriseSlugInvalid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnterpriseSlugInvalidKeySpecifier | (() => undefined | EnterpriseSlugInvalidKeySpecifier),
		fields?: EnterpriseSlugInvalidFieldPolicy,
	},
	FeedbackResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FeedbackResultKeySpecifier | (() => undefined | FeedbackResultKeySpecifier),
		fields?: FeedbackResultFieldPolicy,
	},
	GitHubRepositoryNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GitHubRepositoryNotFoundKeySpecifier | (() => undefined | GitHubRepositoryNotFoundKeySpecifier),
		fields?: GitHubRepositoryNotFoundFieldPolicy,
	},
	GithubRepositoryRelease?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GithubRepositoryReleaseKeySpecifier | (() => undefined | GithubRepositoryReleaseKeySpecifier),
		fields?: GithubRepositoryReleaseFieldPolicy,
	},
	InvalidEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvalidEmailKeySpecifier | (() => undefined | InvalidEmailKeySpecifier),
		fields?: InvalidEmailFieldPolicy,
	},
	Job?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobKeySpecifier | (() => undefined | JobKeySpecifier),
		fields?: JobFieldPolicy,
	},
	JobHeartbeatFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobHeartbeatFailureKeySpecifier | (() => undefined | JobHeartbeatFailureKeySpecifier),
		fields?: JobHeartbeatFailureFieldPolicy,
	},
	JobHeartbeatSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobHeartbeatSuccessKeySpecifier | (() => undefined | JobHeartbeatSuccessKeySpecifier),
		fields?: JobHeartbeatSuccessFieldPolicy,
	},
	JobNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobNotFoundKeySpecifier | (() => undefined | JobNotFoundKeySpecifier),
		fields?: JobNotFoundFieldPolicy,
	},
	LogMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LogMessageKeySpecifier | (() => undefined | LogMessageKeySpecifier),
		fields?: LogMessageFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	OfferInvalidExpiresAt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferInvalidExpiresAtKeySpecifier | (() => undefined | OfferInvalidExpiresAtKeySpecifier),
		fields?: OfferInvalidExpiresAtFieldPolicy,
	},
	OfferInvalidMonthlyPriceUSD?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferInvalidMonthlyPriceUSDKeySpecifier | (() => undefined | OfferInvalidMonthlyPriceUSDKeySpecifier),
		fields?: OfferInvalidMonthlyPriceUSDFieldPolicy,
	},
	OfferInvalidTrialDays?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfferInvalidTrialDaysKeySpecifier | (() => undefined | OfferInvalidTrialDaysKeySpecifier),
		fields?: OfferInvalidTrialDaysFieldPolicy,
	},
	Organization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationKeySpecifier | (() => undefined | OrganizationKeySpecifier),
		fields?: OrganizationFieldPolicy,
	},
	OrganizationDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationDeletedKeySpecifier | (() => undefined | OrganizationDeletedKeySpecifier),
		fields?: OrganizationDeletedFieldPolicy,
	},
	OrganizationHasApps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationHasAppsKeySpecifier | (() => undefined | OrganizationHasAppsKeySpecifier),
		fields?: OrganizationHasAppsFieldPolicy,
	},
	OrganizationHasInboundSubscriptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationHasInboundSubscriptionsKeySpecifier | (() => undefined | OrganizationHasInboundSubscriptionsKeySpecifier),
		fields?: OrganizationHasInboundSubscriptionsFieldPolicy,
	},
	OrganizationHasNoPaymentAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationHasNoPaymentAccountKeySpecifier | (() => undefined | OrganizationHasNoPaymentAccountKeySpecifier),
		fields?: OrganizationHasNoPaymentAccountFieldPolicy,
	},
	OrganizationInvitation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationInvitationKeySpecifier | (() => undefined | OrganizationInvitationKeySpecifier),
		fields?: OrganizationInvitationFieldPolicy,
	},
	OrganizationInvitationDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationInvitationDeletedKeySpecifier | (() => undefined | OrganizationInvitationDeletedKeySpecifier),
		fields?: OrganizationInvitationDeletedFieldPolicy,
	},
	OrganizationInvitationExists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationInvitationExistsKeySpecifier | (() => undefined | OrganizationInvitationExistsKeySpecifier),
		fields?: OrganizationInvitationExistsFieldPolicy,
	},
	OrganizationInvitationNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationInvitationNotFoundKeySpecifier | (() => undefined | OrganizationInvitationNotFoundKeySpecifier),
		fields?: OrganizationInvitationNotFoundFieldPolicy,
	},
	OrganizationInvitationRejected?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationInvitationRejectedKeySpecifier | (() => undefined | OrganizationInvitationRejectedKeySpecifier),
		fields?: OrganizationInvitationRejectedFieldPolicy,
	},
	OrganizationMembership?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationMembershipKeySpecifier | (() => undefined | OrganizationMembershipKeySpecifier),
		fields?: OrganizationMembershipFieldPolicy,
	},
	OrganizationMissingPaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationMissingPaymentMethodKeySpecifier | (() => undefined | OrganizationMissingPaymentMethodKeySpecifier),
		fields?: OrganizationMissingPaymentMethodFieldPolicy,
	},
	OrganizationNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationNotFoundKeySpecifier | (() => undefined | OrganizationNotFoundKeySpecifier),
		fields?: OrganizationNotFoundFieldPolicy,
	},
	OrganizationRenameFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationRenameFailureKeySpecifier | (() => undefined | OrganizationRenameFailureKeySpecifier),
		fields?: OrganizationRenameFailureFieldPolicy,
	},
	OrganizationSlugInvalid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationSlugInvalidKeySpecifier | (() => undefined | OrganizationSlugInvalidKeySpecifier),
		fields?: OrganizationSlugInvalidFieldPolicy,
	},
	OrganizationSlugOccupied?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationSlugOccupiedKeySpecifier | (() => undefined | OrganizationSlugOccupiedKeySpecifier),
		fields?: OrganizationSlugOccupiedFieldPolicy,
	},
	OrganizationTier?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationTierKeySpecifier | (() => undefined | OrganizationTierKeySpecifier),
		fields?: OrganizationTierFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PaymentAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountKeySpecifier | (() => undefined | PaymentAccountKeySpecifier),
		fields?: PaymentAccountFieldPolicy,
	},
	PaymentAccountDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountDeletedKeySpecifier | (() => undefined | PaymentAccountDeletedKeySpecifier),
		fields?: PaymentAccountDeletedFieldPolicy,
	},
	PaymentAccountExists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountExistsKeySpecifier | (() => undefined | PaymentAccountExistsKeySpecifier),
		fields?: PaymentAccountExistsFieldPolicy,
	},
	PaymentAccountHasActiveSubscriptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountHasActiveSubscriptionsKeySpecifier | (() => undefined | PaymentAccountHasActiveSubscriptionsKeySpecifier),
		fields?: PaymentAccountHasActiveSubscriptionsFieldPolicy,
	},
	PaymentAccountNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountNotFoundKeySpecifier | (() => undefined | PaymentAccountNotFoundKeySpecifier),
		fields?: PaymentAccountNotFoundFieldPolicy,
	},
	PaymentAccountURL?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAccountURLKeySpecifier | (() => undefined | PaymentAccountURLKeySpecifier),
		fields?: PaymentAccountURLFieldPolicy,
	},
	PaymentConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentConfigurationKeySpecifier | (() => undefined | PaymentConfigurationKeySpecifier),
		fields?: PaymentConfigurationFieldPolicy,
	},
	PersonalAccessTokenAlreadyExists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonalAccessTokenAlreadyExistsKeySpecifier | (() => undefined | PersonalAccessTokenAlreadyExistsKeySpecifier),
		fields?: PersonalAccessTokenAlreadyExistsFieldPolicy,
	},
	PersonalAccessTokenCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonalAccessTokenCreatedKeySpecifier | (() => undefined | PersonalAccessTokenCreatedKeySpecifier),
		fields?: PersonalAccessTokenCreatedFieldPolicy,
	},
	PersonalAccessTokenEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonalAccessTokenEntryKeySpecifier | (() => undefined | PersonalAccessTokenEntryKeySpecifier),
		fields?: PersonalAccessTokenEntryFieldPolicy,
	},
	PersonalAccessTokenInvalidName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonalAccessTokenInvalidNameKeySpecifier | (() => undefined | PersonalAccessTokenInvalidNameKeySpecifier),
		fields?: PersonalAccessTokenInvalidNameFieldPolicy,
	},
	PlatformMail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlatformMailKeySpecifier | (() => undefined | PlatformMailKeySpecifier),
		fields?: PlatformMailFieldPolicy,
	},
	PublicTool?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PublicToolKeySpecifier | (() => undefined | PublicToolKeySpecifier),
		fields?: PublicToolFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RequestWhiteLabelAccessMail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestWhiteLabelAccessMailKeySpecifier | (() => undefined | RequestWhiteLabelAccessMailKeySpecifier),
		fields?: RequestWhiteLabelAccessMailFieldPolicy,
	},
	ResendEmailVerificationSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResendEmailVerificationSuccessKeySpecifier | (() => undefined | ResendEmailVerificationSuccessKeySpecifier),
		fields?: ResendEmailVerificationSuccessFieldPolicy,
	},
	StandingOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandingOfferKeySpecifier | (() => undefined | StandingOfferKeySpecifier),
		fields?: StandingOfferFieldPolicy,
	},
	StopJobPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StopJobPayloadKeySpecifier | (() => undefined | StopJobPayloadKeySpecifier),
		fields?: StopJobPayloadFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	SubscriptionAlreadyExists?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionAlreadyExistsKeySpecifier | (() => undefined | SubscriptionAlreadyExistsKeySpecifier),
		fields?: SubscriptionAlreadyExistsFieldPolicy,
	},
	SubscriptionOffer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionOfferKeySpecifier | (() => undefined | SubscriptionOfferKeySpecifier),
		fields?: SubscriptionOfferFieldPolicy,
	},
	SubscriptionOfferCheckoutSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionOfferCheckoutSessionKeySpecifier | (() => undefined | SubscriptionOfferCheckoutSessionKeySpecifier),
		fields?: SubscriptionOfferCheckoutSessionFieldPolicy,
	},
	SubscriptionOfferInvalidStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionOfferInvalidStatusKeySpecifier | (() => undefined | SubscriptionOfferInvalidStatusKeySpecifier),
		fields?: SubscriptionOfferInvalidStatusFieldPolicy,
	},
	SubscriptionOfferNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionOfferNotFoundKeySpecifier | (() => undefined | SubscriptionOfferNotFoundKeySpecifier),
		fields?: SubscriptionOfferNotFoundFieldPolicy,
	},
	Tag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TagKeySpecifier | (() => undefined | TagKeySpecifier),
		fields?: TagFieldPolicy,
	},
	Task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskKeySpecifier | (() => undefined | TaskKeySpecifier),
		fields?: TaskFieldPolicy,
	},
	TaskInstance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskInstanceKeySpecifier | (() => undefined | TaskInstanceKeySpecifier),
		fields?: TaskInstanceFieldPolicy,
	},
	TaskInstanceProgress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskInstanceProgressKeySpecifier | (() => undefined | TaskInstanceProgressKeySpecifier),
		fields?: TaskInstanceProgressFieldPolicy,
	},
	TaskInstanceWorkload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskInstanceWorkloadKeySpecifier | (() => undefined | TaskInstanceWorkloadKeySpecifier),
		fields?: TaskInstanceWorkloadFieldPolicy,
	},
	TaskStopResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaskStopResultKeySpecifier | (() => undefined | TaskStopResultKeySpecifier),
		fields?: TaskStopResultFieldPolicy,
	},
	Tool?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ToolKeySpecifier | (() => undefined | ToolKeySpecifier),
		fields?: ToolFieldPolicy,
	},
	ToolDeleteFailure?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ToolDeleteFailureKeySpecifier | (() => undefined | ToolDeleteFailureKeySpecifier),
		fields?: ToolDeleteFailureFieldPolicy,
	},
	ToolDeleteSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ToolDeleteSuccessKeySpecifier | (() => undefined | ToolDeleteSuccessKeySpecifier),
		fields?: ToolDeleteSuccessFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDeletedKeySpecifier | (() => undefined | UserDeletedKeySpecifier),
		fields?: UserDeletedFieldPolicy,
	},
	UserHasSoleAdminship?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserHasSoleAdminshipKeySpecifier | (() => undefined | UserHasSoleAdminshipKeySpecifier),
		fields?: UserHasSoleAdminshipFieldPolicy,
	},
	UserNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNotFoundKeySpecifier | (() => undefined | UserNotFoundKeySpecifier),
		fields?: UserNotFoundFieldPolicy,
	},
	UserOnboardingStepsCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserOnboardingStepsCompletedKeySpecifier | (() => undefined | UserOnboardingStepsCompletedKeySpecifier),
		fields?: UserOnboardingStepsCompletedFieldPolicy,
	},
	UserPreferences?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPreferencesKeySpecifier | (() => undefined | UserPreferencesKeySpecifier),
		fields?: UserPreferencesFieldPolicy,
	},
	VersionCheckCritical?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VersionCheckCriticalKeySpecifier | (() => undefined | VersionCheckCriticalKeySpecifier),
		fields?: VersionCheckCriticalFieldPolicy,
	},
	VersionCheckOK?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VersionCheckOKKeySpecifier | (() => undefined | VersionCheckOKKeySpecifier),
		fields?: VersionCheckOKFieldPolicy,
	},
	VersionCheckWarning?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VersionCheckWarningKeySpecifier | (() => undefined | VersionCheckWarningKeySpecifier),
		fields?: VersionCheckWarningFieldPolicy,
	},
	VersionUnknown?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VersionUnknownKeySpecifier | (() => undefined | VersionUnknownKeySpecifier),
		fields?: VersionUnknownFieldPolicy,
	},
	WhiteLabelConfigNotFound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WhiteLabelConfigNotFoundKeySpecifier | (() => undefined | WhiteLabelConfigNotFoundKeySpecifier),
		fields?: WhiteLabelConfigNotFoundFieldPolicy,
	},
	WorkloadLogEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkloadLogEntryKeySpecifier | (() => undefined | WorkloadLogEntryKeySpecifier),
		fields?: WorkloadLogEntryFieldPolicy,
	},
	WorkloadLogEntryConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkloadLogEntryConnectionKeySpecifier | (() => undefined | WorkloadLogEntryConnectionKeySpecifier),
		fields?: WorkloadLogEntryConnectionFieldPolicy,
	},
	WorkloadResourceUsage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkloadResourceUsageKeySpecifier | (() => undefined | WorkloadResourceUsageKeySpecifier),
		fields?: WorkloadResourceUsageFieldPolicy,
	},
	WorkloadResourceUsageDataPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WorkloadResourceUsageDataPointKeySpecifier | (() => undefined | WorkloadResourceUsageDataPointKeySpecifier),
		fields?: WorkloadResourceUsageDataPointFieldPolicy,
	},
	buildConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | buildConfigurationKeySpecifier | (() => undefined | buildConfigurationKeySpecifier),
		fields?: buildConfigurationFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AppAPIKeyCreateResult": [
      "AppAPIKey",
      "AppAPIKeyAlreadyExists",
      "AppAPIKeyInvalidName"
    ],
    "AppDeleteResult": [
      "AppDeleted",
      "AppHasActiveSubscriptions"
    ],
    "AppDeployEvent": [
      "AppBuildErrorEvent",
      "AppBuildMessageEvent",
      "AppDeploymentStatusEvent"
    ],
    "AppSubscriptionCancelResult": [
      "AppSubscription",
      "AppSubscriptionInvalidStatus",
      "AppSubscriptionNotFound"
    ],
    "AppVersionCreateGitHubResult": [
      "AppVersion",
      "GitHubRepositoryNotFound"
    ],
    "BuildEvent": [
      "BuildEventFailure",
      "BuildEventInfo",
      "BuildEventSuccess"
    ],
    "CollectionCreateResult": [
      "Collection",
      "CollectionNotFound",
      "CollectionOrganizationMismatch"
    ],
    "CollectionDocumentDeleteResult": [
      "CollectionDocument",
      "CollectionDocumentNotFound"
    ],
    "CollectionDocumentResult": [
      "CollectionDocument",
      "CollectionDocumentNotFound"
    ],
    "CollectionDocumentSetResult": [
      "CollectionDocument",
      "CollectionNotFound"
    ],
    "CollectionFileCreateResult": [
      "CollectionFile",
      "CollectionNotFound"
    ],
    "CollectionFileDeleteResult": [
      "CollectionFile",
      "CollectionFileNotFound"
    ],
    "CollectionFileResult": [
      "CollectionFile",
      "CollectionFileNotFound"
    ],
    "CollectionResult": [
      "Collection",
      "CollectionNotFound"
    ],
    "EnterpriseCreateResult": [
      "Enterprise",
      "EnterpriseInvalidMaxOrganizations",
      "EnterpriseInvalidUnitsCount",
      "EnterpriseSlugInvalid"
    ],
    "EnterpriseMemberAddResult": [
      "Enterprise",
      "EnterpriseNotFound",
      "UserNotFound"
    ],
    "EnterpriseMemberRemoveResult": [
      "Enterprise",
      "EnterpriseNotFound",
      "UserNotFound"
    ],
    "EnterprisePlanChangeResult": [
      "Enterprise",
      "EnterpriseInvalidMaxOrganizations",
      "EnterpriseInvalidUnitsCount",
      "EnterpriseNotFound"
    ],
    "EnterpriseQueryResult": [
      "Enterprise",
      "EnterpriseNotFound"
    ],
    "JobHeartbeatResult": [
      "JobHeartbeatFailure",
      "JobHeartbeatSuccess",
      "JobNotFound"
    ],
    "MeDeleteResult": [
      "UserDeleted",
      "UserHasSoleAdminship",
      "UserNotFound"
    ],
    "OrganizationCreateResult": [
      "Organization",
      "OrganizationSlugInvalid",
      "OrganizationSlugOccupied"
    ],
    "OrganizationDeleteResult": [
      "OrganizationDeleted",
      "OrganizationHasApps",
      "OrganizationHasInboundSubscriptions",
      "OrganizationNotFound"
    ],
    "OrganizationInvitationAcceptResult": [
      "Organization",
      "OrganizationNotFound"
    ],
    "OrganizationInvitationCreateResult": [
      "InvalidEmail",
      "OrganizationInvitation",
      "OrganizationInvitationExists",
      "OrganizationNotFound"
    ],
    "OrganizationInvitationDeleteResult": [
      "OrganizationInvitationDeleted",
      "OrganizationInvitationNotFound",
      "OrganizationNotFound"
    ],
    "OrganizationInvitationQueryResult": [
      "OrganizationInvitation",
      "OrganizationInvitationNotFound",
      "OrganizationNotFound"
    ],
    "OrganizationInvitationRejectResult": [
      "OrganizationInvitationNotFound",
      "OrganizationInvitationRejected",
      "OrganizationNotFound"
    ],
    "OrganizationLinkToEnterpriseResult": [
      "EnterpriseNotFound",
      "Organization",
      "OrganizationNotFound"
    ],
    "OrganizationMemberEditRoleResult": [
      "OrganizationMembership",
      "OrganizationNotFound",
      "UserNotFound"
    ],
    "OrganizationMemberRemoveResult": [
      "Organization",
      "OrganizationNotFound",
      "UserNotFound"
    ],
    "OrganizationQueryResult": [
      "Organization",
      "OrganizationNotFound"
    ],
    "OrganizationRenameResult": [
      "Organization",
      "OrganizationNotFound",
      "OrganizationRenameFailure"
    ],
    "OrganizationTierChangeResult": [
      "Organization",
      "OrganizationNotFound"
    ],
    "PaymentAccountCreateResult": [
      "PaymentAccount",
      "PaymentAccountExists"
    ],
    "PaymentAccountDeleteResult": [
      "PaymentAccountDeleted",
      "PaymentAccountHasActiveSubscriptions",
      "PaymentAccountNotFound"
    ],
    "PaymentAccountURLResult": [
      "PaymentAccountNotFound",
      "PaymentAccountURL"
    ],
    "PersonalAccessTokenCreateResult": [
      "PersonalAccessTokenAlreadyExists",
      "PersonalAccessTokenCreated",
      "PersonalAccessTokenInvalidName"
    ],
    "RequestWhiteLabelAccessResult": [
      "InvalidEmail",
      "RequestWhiteLabelAccessMail",
      "WhiteLabelConfigNotFound"
    ],
    "ResendEmailVerificationResult": [
      "ResendEmailVerificationSuccess",
      "UserNotFound"
    ],
    "StandingOfferAcceptResult": [
      "AppSubscription",
      "OrganizationMissingPaymentMethod",
      "SubscriptionAlreadyExists",
      "SubscriptionOfferCheckoutSession",
      "SubscriptionOfferInvalidStatus",
      "SubscriptionOfferNotFound"
    ],
    "StandingOfferCreateResult": [
      "OfferInvalidMonthlyPriceUSD",
      "OfferInvalidTrialDays",
      "OrganizationHasNoPaymentAccount",
      "StandingOffer"
    ],
    "StandingOfferResult": [
      "StandingOffer",
      "SubscriptionOfferNotFound"
    ],
    "SubscriptionOfferAcceptResult": [
      "AppSubscription",
      "OrganizationMissingPaymentMethod",
      "SubscriptionOfferCheckoutSession",
      "SubscriptionOfferInvalidStatus",
      "SubscriptionOfferNotFound"
    ],
    "SubscriptionOfferCreateResult": [
      "InvalidEmail",
      "OfferInvalidExpiresAt",
      "OfferInvalidMonthlyPriceUSD",
      "OfferInvalidTrialDays",
      "OrganizationHasNoPaymentAccount",
      "SubscriptionOffer"
    ],
    "SubscriptionOfferRejectResult": [
      "SubscriptionOffer",
      "SubscriptionOfferInvalidStatus",
      "SubscriptionOfferNotFound"
    ],
    "SubscriptionOfferResult": [
      "SubscriptionOffer",
      "SubscriptionOfferNotFound"
    ],
    "SubscriptionOfferWithdraw": [
      "SubscriptionOffer",
      "SubscriptionOfferInvalidStatus",
      "SubscriptionOfferNotFound"
    ],
    "ToolDeleteResult": [
      "ToolDeleteFailure",
      "ToolDeleteSuccess"
    ],
    "VersionCheckResult": [
      "VersionCheckCritical",
      "VersionCheckOK",
      "VersionCheckWarning",
      "VersionUnknown"
    ],
    "appAPIKeyRenameResult": [
      "AppAPIKey",
      "AppAPIKeyInvalidName"
    ]
  }
};
      export default result;
    